import React, { useRef, useState, useEffect } from 'react';
import { Bubble } from '@ant-design/x';
import { Display } from '@/components/Display/Display';
import { defaultPlugins, colorOptions, styleOptions } from '@/utils/Page/constant';
import { getRoles, getUserId } from '@/utils/Page';
import SkillList from '../SkillList';
import WebSender from '../WebSender';
import Toast from '@/components/Toast';
import AIMarks from '@/components/AiMark';
// import s from '../../Outside/pages/style/chat.module.scss';
import s from './index.module.scss';
import { handleAIPPTChat, handleAIPPTCoverUpdate, handleAIPPTCreate, handleAIPPTResult, handleAIPPTEditor, handleAIPPTDownload } from '@/api/grt/ai';
import AIPPTExample from './example.jsx'; // 导入example组件
import TemplateSelector from './TemplateSelector'; // 导入模板选择器组件
import ImageWithButtons from './ImageWithButtons'; // 导入图片按钮组件
import DotsLoading from './DotsLoading';
import PreQuestion from './PreQuestion';
import errImg from '@/assets/images/usual/errImg.webp';

import { getSearchStr } from '@/utils/Page';
let searchStr = getSearchStr();
const AIPPT = ({
    skillStore,
    checkIsLogin,
    conversationId,
    skillId,
    curSkill,
    setCurSkill,
    // 从父组件传入的聊天相关props
    sessionMap = {},
    currentAgent = {},
    sessionId,
    loading = false,
    content = '',
    setContent,
    skillList = { unApartList: [] },
    curPlugin,
    setCurPlugin,
    submitMsg,
    skillPreQuestion = [],
    clickGuide,
    agentFile,
    setAgentFile,
    agentFileRef,
    style = { themeColor: 1 },
    editPlanMode = false,
    toggleEditPlanMode,
    resetEditPlanMode,
    isInputVisible = true,
    showTTSComponent = false,
    showChatInterface = true,
    onTTSToggle,
    stopDeerFlow,
    generatingReports = {},
    sidebarOpen = false,
    activeReportId,
    handleStartNewMsg,
    sessionStatus,
    // 添加agentId参数
    agentId,
    // 🔥 新增：会话列表更新函数
    getHistorySessionList,
    // 🔥 新增：导航函数
    linkToSession,
    // 🔥 新增：格式化会话列表函数
    formatSessionList,
    // 🔥 新增：会话列表引用
    sessionListRef,
    // 🔥 新增：消息处理函数
    handleMessages,
    // 🔥 新增：会话映射操作函数
    changeSessionMapItem,
    // 🔥 新增：原始消息映射操作函数
    changeOriginMsgMapRef,
    // 🔥 新增：原始消息映射引用
    originMsgMapRef,
    // 🔥 新增：AIPPT历史消息处理函数
    handleAIPPTHistoryMessage,
    // 🔥 新增：获取会话消息函数
    handleGetSessionMessage
}) => {
    const listRef = useRef();
    const [aipptLoading, setAipptLoading] = useState(false);
    const [messages, setMessages] = useState([]); // 添加本地消息状态
    const [loadingMessageSessionId, setLoadingMessageSessionId] = useState(null); // 🔥 新增：跟踪加载消息所在的sessionId
    const fakeToRealTransitionRef = useRef(false); // 🔥 新增：跟踪是否已经处理过假会话到真实会话的跳转
    const [selectedTemplate, setSelectedTemplate] = useState(null); // 选中的模板
    const [selectedColor, setSelectedColor] = useState(0); // 选中的主题色，默认蓝色
    const [selectedStyle, setSelectedStyle] = useState('科技风'); // 选中的风格
    const [loadingCovers, setLoadingCovers] = useState({}); // 🔥 修改：使用对象管理每个模板选择器的加载状态，key为recordId
    const [coverImages, setCoverImages] = useState([]); // 封面图片列表
    const loadingCoversStartTimeRef = useRef({}); // 🔥 新增：记录每个 recordId 设置加载状态的时间戳

    // 🔥 新增：API请求状态管理
    const [apiRequestStatus, setApiRequestStatus] = useState({
        isPending: false, // 是否有请求正在进行
        requestId: null, // 当前请求的唯一ID
        requestType: null, // 请求类型：'cover', 'template', 'generate'
        startTime: null // 请求开始时间
    });
    // 🔥 处理图片加载失败
    const handleImageError = (e) => {
        if (e.target.src !== errImg) {
            e.target.src = errImg;
        }
    };

    // 🔥 添加 useEffect 监听 messages 状态变化
    // 🔥 新增：当sessionId变化时，验证是否属于AIPPT会话，如果不是则清空消息
    useEffect(() => {
        if (sessionId && !sessionId.startsWith('fake_') && sessionId !== 'undefined' && sessionMap?.[sessionId]) {
            const effectiveSessionId = localStorage.getItem('aippt_prev_session_id');
            const sessionData = sessionMap[effectiveSessionId];
            setMessages([]);

            // 🔥 新增：检查切换回的会话是否有正在加载的消息，如果有则派发加载开始事件
            const hasLoadingMessage = sessionData?.messages?.some(
                (msg) =>
                    msg.loading === true ||
                    (msg.content && React.isValidElement(msg.content) && msg.content.type === DotsLoading) ||
                    (typeof msg.content === 'string' && msg.content.includes('正在生成'))
            );

            if (hasLoadingMessage) {
                // 派发AIPPT加载开始事件，让WebSender显示暂停图标
                window.dispatchEvent(
                    new CustomEvent('aippt-loading-start', {
                        detail: {
                            sessionId: sessionId,
                            timestamp: Date.now(),
                            type: 'session_switch_back' // 标记为会话切换回来
                        }
                    })
                );
            }
        }
    }, [sessionId, sessionMap]);

    // 🔥 修改：优化 sessionId 变化的处理逻辑
    useEffect(() => {
        const prevSessionId = getPrevSessionId();

        // 如果sessionId没有实际变化，不处理
        if (prevSessionId === sessionId) {
            return;
        }

        // 🔥 修改：从假会话跳转到真实会话时，保持本地消息状态
        const isFromFakeToReal = prevSessionId && prevSessionId.startsWith('fake_') && sessionId && !sessionId.startsWith('fake_');

        if (isFromFakeToReal) {
            fakeToRealTransitionRef.current = true; // 标记已处理过跳转
            setPrevSessionId(sessionId); // 更新存储

            // 🔥 新增：等待历史数据加载完成，如果sessionMap中还没有数据，延迟一下再检查
            if (!sessionMap?.[sessionId]?.messages) {
                setTimeout(() => {
                    if (sessionMap?.[sessionId]?.messages?.length > 0) {
                        debugSetMessages([...sessionMap[sessionId].messages], 'fake_to_real_delayed_sync');
                    } else {
                        // 🔥 方案1：优先使用props传递的handleGetSessionMessage函数
                        if (handleGetSessionMessage && typeof handleGetSessionMessage === 'function') {
                            const sessionObj = { session_id: sessionId, skill_id: curSkill?.ability_id || skillId };
                            try {
                                handleGetSessionMessage(sessionObj);
                            } catch (error) {
                                console.error('🔥 props handleGetSessionMessage调用失败:', error);
                            }
                        }
                        // 🔥 方案1b：如果props没有，尝试全局handleGetSessionMessage函数
                        else if (typeof window.handleGetSessionMessage === 'function') {
                            const sessionObj = { session_id: sessionId, skill_id: curSkill?.ability_id || skillId };
                            try {
                                window.handleGetSessionMessage(sessionObj);
                            } catch (error) {
                                console.error('🔥 全局handleGetSessionMessage调用失败:', error);
                            }
                        }
                        // 🔥 方案2：如果没有全局函数，但有handleAIPPTHistoryMessage，尝试构造空历史记录
                        else if (handleAIPPTHistoryMessage && typeof handleAIPPTHistoryMessage === 'function') {
                            const sessionObj = { session_id: sessionId };
                            handleAIPPTHistoryMessage([], sessionObj)
                                .then(() => {})
                                .catch((error) => {
                                    console.error('🔥 主动调用handleAIPPTHistoryMessage失败:', error);
                                });
                        }
                        // 🔥 方案3：如果都没有，至少确保localStorage中的会话ID是正确的
                        else {
                            localStorage.setItem('aippt_prev_session_id', sessionId);
                        }
                    }
                }, 100);
            }

            return; // 不清空消息，保持当前状态
        }

        // 🔥 修复：如果刚刚处理过假会话到真实会话的跳转，不要清空消息
        if (fakeToRealTransitionRef.current && sessionId && !sessionId.startsWith('fake_')) {
            setPrevSessionId(sessionId);
            return;
        }

        // 🔥 新增：如果是点击会话列表切换到已有会话，历史记录由useChat.js统一处理
        if (sessionId && prevSessionId && prevSessionId !== '' && !sessionId.startsWith('fake_')) {
            // 这里不需要额外处理，useChat.js会自动调用handleAIPPTHistoryMessage
        } else if (sessionId && sessionMap?.[sessionId]?.messages) {
            // 当切换到新会话时，如果 sessionMap 中有该会话的消息，同步到本地状态

            // 🔥 新增：对 sessionMap 中的消息也进行安全检查
            const sessionMessages = sessionMap[sessionId].messages;
            const safeSessionMessages = sessionMessages.map((msg, index) => {
                if (!msg || !msg.content) {
                    return msg;
                }

                let safeContent = msg.content;

                // 检查 content 是否为普通对象（非 React 元素）
                if (safeContent && typeof safeContent === 'object' && !React.isValidElement(safeContent) && safeContent.constructor === Object) {
                    // 检查是否为AIPPT相关的数据结构
                    const isAIPPTData =
                        safeContent.ongoing_status !== undefined ||
                        safeContent.theme !== undefined ||
                        safeContent.catalogs !== undefined ||
                        safeContent.title !== undefined;

                    if (isAIPPTData) {
                        // 保持原始数据结构，让后续的 getItem() 函数处理
                    } else {
                        // 其他类型的对象，转换为JSON字符串以便显示
                        safeContent = JSON.stringify(safeContent, null, 2);
                    }
                }

                return {
                    ...msg,
                    content: safeContent
                };
            });

            setMessages(safeSessionMessages);
        } else if (
            sessionId &&
            prevSessionId &&
            prevSessionId !== '' &&
            !prevSessionId.startsWith('fake_') &&
            !sessionId.startsWith('fake_') &&
            sessionId !== 'undefined' &&
            prevSessionId !== 'undefined'
        ) {
            // 只有在真正切换到不同的有效会话时才清空本地消息
            setMessages([]);
        } else if (!sessionId && prevSessionId) {
            // 🔥 当sessionId变为undefined时（通常表示正在切换会话），清空消息
            setMessages([]);
            fakeToRealTransitionRef.current = false; // 重置跳转标记
        }

        // 更新前一个 sessionId 存储
        setPrevSessionId(sessionId);
    }, [sessionId]); // 🔥 修复：只监听sessionId变化，使用ref避免重复处理

    // 🔥 新增：单独处理 sessionMap 变化，同步消息到本地状态
    useEffect(() => {
        // 只有在有效的sessionId且不是假会话时才同步
        if (sessionId && !sessionId.startsWith('fake_') && sessionId !== 'undefined' && sessionMap?.[sessionId]?.messages) {
            const sessionMessages = sessionMap[sessionId].messages;

            // 🔥 新增：检测到通用技能消息完成时，派发加载完成事件
            // 判断条件：当前不是AIPPT技能 且 sessionMap中loading为false
            const isAIPPTSkill =
                curSkill?.ability_id !== '-1' &&
                curSkill?.ability_id !== -1 &&
                (curSkill?.third_json?.handler === 'aippt' || skillId === '1957685884025380865');

            if (!isAIPPTSkill && sessionMap[sessionId]?.loading === false) {
                // 派发通用技能消息完成事件，让WebSender隐藏暂停图标
                window.dispatchEvent(
                    new CustomEvent('aippt-loading-complete', {
                        detail: {
                            sessionId: sessionId,
                            timestamp: Date.now(),
                            type: 'universal_skill_complete' // 标记为通用技能完成
                        }
                    })
                );
            }

            // 🔥 修复：添加API请求状态检查，避免在API请求进行中时同步旧数据
            if (apiRequestStatus.isPending) {
                return;
            }

            // 🔥 如果是从假会话跳转到真实会话，需要特殊处理
            if (fakeToRealTransitionRef.current) {
                fakeToRealTransitionRef.current = false; // 重置跳转标记
                // 不return，继续执行下面的同步逻辑
            }

            // 🔥 修复：检查是否有正在加载的消息，如果有则不同步，避免覆盖加载状态
            const checkLoadingMessage = (msgArray) => {
                return msgArray.some(
                    (msg) =>
                        msg.loading === true ||
                        (msg.content && React.isValidElement(msg.content) && msg.content.type === DotsLoading) ||
                        (msg.content &&
                            React.isValidElement(msg.content) &&
                            msg.content.props &&
                            typeof msg.content.props === 'object' &&
                            Object.values(msg.content.props).some(
                                (v) =>
                                    typeof v === 'string' &&
                                    (v.includes('正在生成PPT模板') || v.includes('正在为主题') || v.includes('正在生成AI PPT大纲'))
                            ))
                );
            };

            // 检查本地消息、sessionMap消息和originMsgMapRef中是否有加载状态
            const hasLoadingInLocal = checkLoadingMessage(messages);
            const hasLoadingInSession = checkLoadingMessage(sessionMessages);

            // 🔥 新增：检查 originMsgMapRef 中是否有加载消息
            let hasLoadingInOrigin = false;
            if (sessionId && originMsgMapRef?.current?.[sessionId]?.messages) {
                hasLoadingInOrigin = checkLoadingMessage(originMsgMapRef.current[sessionId].messages);
            }

            // 🔥 新增：如果sessionMap中有加载消息，派发加载开始事件
            if (hasLoadingInSession && !hasLoadingInLocal) {
                window.dispatchEvent(
                    new CustomEvent('aippt-loading-start', {
                        detail: {
                            sessionId: sessionId,
                            timestamp: Date.now(),
                            type: 'session_sync_loading' // 标记为会话同步加载状态
                        }
                    })
                );
            }

            // 🔥 新增：如果API请求正在进行中，也不同步
            if (apiRequestStatus.isPending || hasLoadingInLocal || hasLoadingInSession || hasLoadingInOrigin) {
                return;
            }

            // 🔥 修复：更严格的同步条件，避免重复同步相同内容
            const shouldSync = sessionMessages.length > messages.length && JSON.stringify(sessionMessages) !== JSON.stringify(messages);

            if (shouldSync) {
                // 🔥 新增：最后一次检查，确保不会覆盖正在进行的API请求产生的加载消息
                const currentTime = Date.now();
                const recentApiRequest = apiRequestStatus.isPending && currentTime - apiRequestStatus.startTime < 30000; // 30秒内的请求

                if (recentApiRequest) {
                    return;
                }
                debugSetMessages([...sessionMessages]);
            }
        }
    }, [sessionMap, sessionId, apiRequestStatus.isPending]); // 🔥 修复：添加apiRequestStatus.isPending依赖

    // 🔥 新增：根据历史数据初始化颜色和风格选择状态
    useEffect(() => {
        const effectiveSessionId = localStorage.getItem('aippt_prev_session_id');
        let messagesArray = [];

        // 优先从originMsgMapRef获取最新数据
        if (effectiveSessionId && originMsgMapRef?.current?.[effectiveSessionId]?.messages) {
            messagesArray = originMsgMapRef.current[effectiveSessionId].messages;
        } else if (messages.length > 0) {
            messagesArray = messages;
        }

        // 查找最新的模板选择器消息（从后往前查找）
        let templateMessage = null;
        for (let i = messagesArray.length - 1; i >= 0; i--) {
            const msg = messagesArray[i];
            if (
                msg.role === 'assistant' &&
                ((msg.apiData && (msg.apiData.cover_image_list || msg.apiData.color || msg.apiData.style)) ||
                    (React.isValidElement(msg.content) && msg.content.type === TemplateSelector) ||
                    (msg.content && typeof msg.content === 'object' && (msg.content.cover_image_list || msg.content.color || msg.content.style)) ||
                    // 🔥 识别ongoing_status为"0"的aippt_result消息
                    (msg.content && typeof msg.content === 'object' && msg.content.ongoing_status === '0' && msg.content_type === 'aippt_result'))
            ) {
                templateMessage = msg;
                break;
            }
        }

        if (templateMessage) {
            let historyColor = null;
            let historyStyle = null;

            // 从apiData获取
            if (templateMessage.apiData) {
                historyColor = templateMessage.apiData.color;
                historyStyle = templateMessage.apiData.style;
            }
            // 从React组件props获取
            else if (React.isValidElement(templateMessage.content) && templateMessage.content.props?.historyData) {
                historyColor = templateMessage.content.props.historyData.color;
                historyStyle = templateMessage.content.props.historyData.style;
            }
            // 从普通对象获取
            else if (templateMessage.content && typeof templateMessage.content === 'object') {
                historyColor = templateMessage.content.color;
                historyStyle = templateMessage.content.style;
            }

            // 更新选中状态
            if (historyColor) {
                const colorIndex = colorOptions.findIndex((option) => option.name === historyColor);
                if (colorIndex !== -1 && colorIndex !== selectedColor) {
                    setSelectedColor(colorIndex);
                }
            }

            if (historyStyle && historyStyle !== selectedStyle) {
                setSelectedStyle(historyStyle);
            }
        }
    }, [messages, sessionId]); // 当消息或会话变化时重新初始化

    // 🔥 新增：通用的完成状态检查函数
    const checkIsCompleted = (currentMsg, messagesArray) => {
        // 🔥 新增：首先检查当前消息的 ongoing_status 是否为 "3"（已完成）
        const msgContent = currentMsg.content;
        if (msgContent && typeof msgContent === 'object' && msgContent.ongoing_status === '3') {
            return true;
        }

        // 通过消息的唯一标识查找位置
        let currentIndex = -1;

        // 尝试多种方式匹配当前消息
        for (let i = 0; i < messagesArray.length; i++) {
            const msg = messagesArray[i];
            if (
                // 通过_id匹配
                (currentMsg._id && msg._id === currentMsg._id) ||
                // 通过apiData._id匹配
                (currentMsg.apiData?._id && msg.apiData?._id === currentMsg.apiData._id) ||
                // 通过timestamp匹配（如果有的话）
                (currentMsg.timestamp && msg.timestamp === currentMsg.timestamp) ||
                // 通过recordId匹配
                (currentMsg.apiData?._id && (msg.apiData?._id === currentMsg.apiData._id || msg._id === currentMsg.apiData._id)) ||
                // 🔥 新增：通过messageType和apiData内容匹配模板选择器
                (currentMsg.messageType === 'template_selector' &&
                    msg.messageType === 'template_selector' &&
                    currentMsg.apiData?._id &&
                    msg.apiData?._id === currentMsg.apiData?._id)
            ) {
                currentIndex = i;
                break;
            }
        }

        // 如果找到当前消息，检查后续消息是否有PPT生成结果
        if (currentIndex >= 0) {
            return messagesArray.slice(currentIndex + 1).some((laterMsg) => {
                const content = laterMsg.content;
                // 检查是否为PPT生成结果
                return (
                    content &&
                    typeof content === 'object' &&
                    ((content.content_type === 'aippt_result' && content.images_url) ||
                        (content.images_url && content.status === 2) ||
                        (React.isValidElement(content) && content.type && content.type.name === 'ImageWithButtons') ||
                        // 🔥 新增：检查pptData中的结果
                        (content.pptData && (content.pptData.images_url || content.pptData.status === 2)))
                );
            });
        }

        return false;
    };

    // 🔥 新增：根据接口返回的颜色和风格获取默认选中状态的函数
    const getDefaultSelectionFromResponse = (responseData) => {
        // 默认值：紫色和科技风
        let defaultColor = 0; // 蓝色的索引
        let defaultStyle = '科技风';

        // 🔥 新增：首先检查responseData直接的color和style字段
        if (responseData?.color) {
            const colorIndex = colorOptions.findIndex((option) => option.name === responseData.color);
            if (colorIndex !== -1) {
                defaultColor = colorIndex;
            }
        }

        if (responseData?.style) {
            defaultStyle = responseData.style;
        }

        if (responseData && responseData.cover_image_list && responseData.cover_image_list.length > 0) {
            const firstCover = responseData.cover_image_list[0];

            // 根据返回的颜色设置默认选中颜色
            if (firstCover.color) {
                const colorIndex = colorOptions.findIndex((option) => option.name === firstCover.color);
                if (colorIndex !== -1) {
                    defaultColor = colorIndex;
                }
            }

            // 根据返回的风格设置默认选中风格
            if (firstCover.style) {
                defaultStyle = firstCover.style;
            }
        }
        return { defaultColor, defaultStyle };
    };

    // 🔥 新增：通用的消息替换函数
    const replaceLoadingMessage = (newContent, options = {}) => {
        const {
            findPattern = (msg) => {
                // 首先检查loading标志
                if (msg.loading) return true;

                // 检查React组件内容
                if (msg.content && React.isValidElement(msg.content)) {
                    try {
                        const props = msg.content.props;
                        if (props && typeof props === 'object') {
                            const propsStr =
                                Object.keys(props).join(' ') +
                                ' ' +
                                Object.values(props)
                                    .filter((v) => typeof v === 'string')
                                    .join(' ');
                            // 🔥 修复：添加更多匹配模式
                            if (
                                propsStr.includes('正在生成PPT模板') ||
                                propsStr.includes('正在为主题') ||
                                propsStr.includes('生成PPT模板') ||
                                propsStr.includes('正在生成AI PPT大纲') ||
                                propsStr.includes('正在生成PPT大纲')
                            ) {
                                return true;
                            }
                        }
                    } catch (error) {
                        console.error('🔥 检查React组件时出错:', error.message);
                    }
                }

                // 检查字符串内容
                if (
                    typeof msg.content === 'string' &&
                    (msg.content.includes('正在生成PPT模板') ||
                        msg.content.includes('正在为主题') ||
                        msg.content.includes('生成PPT模板') ||
                        msg.content.includes('正在生成AI PPT大纲') ||
                        msg.content.includes('正在生成PPT大纲'))
                ) {
                    return true;
                }

                return false;
            }, // 查找模式
            messageProps = {}, // 新消息的额外属性
            sessionId: targetSessionId = sessionId, // 目标会话ID
            syncToSessionMap = true // 是否同步到sessionMap
        } = options;

        // 获取有效的sessionId
        let effectiveSessionId = localStorage.getItem('aippt_prev_session_id');
        if (!effectiveSessionId && sessionMap && Object.keys(sessionMap).length > 0) {
            effectiveSessionId = Object.keys(sessionMap)[0];
        }

        // 🔥 修复：优先从originMsgMapRef获取最新消息，这是最新的数据源
        let baseMessages = [];
        if (effectiveSessionId && originMsgMapRef[effectiveSessionId]?.messages) {
            baseMessages = [...originMsgMapRef[effectiveSessionId].messages];
        }

        // 查找并替换加载消息
        let foundMessage = false;
        // 🔥 新增：调试信息

        for (let i = baseMessages.length - 1; i >= 0; i--) {
            const currentMsg = baseMessages[i];
            const willMatch = findPattern(currentMsg);

            if (willMatch) {
                foundMessage = true;

                // 替换消息
                const { loading, loadingId, requestId, ...cleanMsg } = currentMsg;
                const newMessage = {
                    ...cleanMsg, // 🔥 使用清理后的消息对象
                    role: 'assistant',
                    content: newContent,
                    timestamp: Date.now(),
                    // 🔥 标记这是API成功返回的数据
                    isApiSuccess: true,
                    // 🔥 移除对apiRequestStatus.requestId的依赖，使用当前时间戳
                    apiRequestId: Date.now(),
                    // 🔥 确保loading相关属性被完全移除
                    loading: false, // 明确设置为false
                    ...messageProps
                };
                baseMessages[i] = newMessage;

                break;
            }
        }

        if (!foundMessage) {
            baseMessages.push({
                role: 'assistant',
                content: newContent,
                timestamp: Date.now(),
                isApiSuccess: true,
                apiRequestId: Date.now(),
                ...messageProps
            });
        }

        // 更新本地状态
        debugSetMessages(baseMessages, 'replaceLoadingMessage');

        // 同步到sessionMap

        if (syncToSessionMap && effectiveSessionId && changeSessionMapItem && typeof changeSessionMapItem === 'function') {
            try {
                changeSessionMapItem(
                    effectiveSessionId,
                    {
                        messages: baseMessages
                    },
                    baseMessages
                );
            } catch (error) {
                console.error('🔥 sessionMap同步失败:', error);
            }
        } else {
            console.warn('🔥 replaceLoadingMessage - 无法同步到sessionMap:', {
                syncToSessionMap,
                effectiveSessionId,
                hasChangeSessionMapItem: !!changeSessionMapItem,
                changeSessionMapItemType: typeof changeSessionMapItem
            });
        }

        // 🔥 注释：originMsgMapRef 是用来获取最新数据的，不需要手动设置

        // 🔥 清除API请求状态（如果状态还存在的话）
        if (apiRequestStatus.isPending) {
            setApiRequestStatus({
                isPending: false,
                requestId: null,
                requestType: null,
                startTime: null
            });
        }

        return { success: true, messages: baseMessages };
    };

    // 🔥 使用 localStorage 来跟踪前一个 sessionId，避免组件重新挂载导致的状态丢失
    const PREV_SESSION_KEY = 'aippt_prev_session_id';
    const getPrevSessionId = () => localStorage.getItem(PREV_SESSION_KEY);
    const setPrevSessionId = (id) => localStorage.setItem(PREV_SESSION_KEY, id || '');

    // 🔥 新增：调试用的setMessages包装函数
    const debugSetMessages = (newMessages, source = 'unknown') => {
        if (typeof newMessages === 'function') {
            setMessages((prev) => {
                const result = newMessages(prev);
                return result;
            });
        } else {
            setMessages(newMessages);
        }
    };

    // AI PPT 专用的消息提交函数
    const handleAIPPTSubmit = async (msg) => {
        let message = typeof msg === 'string' ? msg : String(msg?.question || '');
        let isLogin = await checkIsLogin();
        if (!isLogin) {
            return false;
        }
        console.log('aipptLoading', aipptLoading);
        if (aipptLoading) {
            return;
        }

        // 🔥 新增：检查当前是否是AIPPT技能，如果不是则使用通用技能对话
        // 判断逻辑：
        // 1. curSkill.ability_id === "-1" 表示已切换为通用技能
        // 2. curSkill.third_json?.handler !== 'aippt' 表示不是AIPPT类型的技能
        // 3. skillId !== '1957685884025380865' 表示不是AIPPT的固定技能ID（备用判断）
        const isAIPPTSkill =
            curSkill?.ability_id !== '-1' &&
            curSkill?.ability_id !== -1 &&
            (curSkill?.third_json?.handler === 'aippt' || skillId === '1957685884025380865');
        console.log('isAIPPTSkill', isAIPPTSkill);
        if (!isAIPPTSkill) {
            // 当前不是AIPPT技能，使用通用技能的submitMsg函数
            if (submitMsg && typeof submitMsg === 'function') {
                return submitMsg(message);
            } else {
                console.error('🔥 submitMsg函数不可用，无法发送消息');
                return;
            }
        }

        // 清空输入框内容
        setContent('');

        try {
            setAipptLoading(true);

            // 🔥 新增：派发AIPPT加载开始事件
            window.dispatchEvent(
                new CustomEvent('aippt-loading-start', {
                    detail: {
                        sessionId: sessionId,
                        timestamp: Date.now()
                    }
                })
            );

            // 🔥 新增：发送新消息时，将所有历史可操作组件设置为完成状态
            const markAllHistoryAsCompleted = () => {
                // 获取当前消息数组
                let currentMessages = [];
                const effectiveSessionId = localStorage.getItem('aippt_prev_session_id') || sessionId || 0;

                // 🔥 修复：优先从originMsgMapRef获取最新数据，如果没有则从sessionMap或本地messages获取
                if (effectiveSessionId && originMsgMapRef?.[effectiveSessionId]?.messages) {
                    currentMessages = [...originMsgMapRef?.[effectiveSessionId]?.messages];
                }

                // 🔥 如果没有消息，提前返回
                if (currentMessages.length === 0) {
                    return;
                }

                // 遍历消息，将可操作组件的 ongoing_status 设置为 "3"
                const updatedMessages = currentMessages.map((msg, index) => {
                    // 🔥 修复：检查是否为需要设置完成状态的组件类型
                    const shouldMarkCompleted =
                        // 检查模板选择器（React组件）
                        (React.isValidElement(msg.content) && msg.content.type && msg.content.type.name === 'TemplateSelector') ||
                        // 检查模板选择器（messageType标识）
                        msg.messageType === 'template_selector' ||
                        // 检查大纲编辑器（React组件）
                        (React.isValidElement(msg.content) && msg.content.type && msg.content.type.name === 'AIPPTExample') ||
                        // 检查大纲编辑器（messageType标识）
                        msg.messageType === 'outline_editor' ||
                        // 检查普通对象中的大纲数据
                        (msg.content &&
                            typeof msg.content === 'object' &&
                            !React.isValidElement(msg.content) &&
                            (msg.content.catalogs !== undefined || msg.content.title !== undefined) &&
                            msg.content.ongoing_status &&
                            msg.content.ongoing_status !== '3' &&
                            msg.content.ongoing_status !== '2') || // 🔥 新增：跳过失败状态
                        // 检查普通对象中的模板选择数据
                        (msg.content &&
                            typeof msg.content === 'object' &&
                            !React.isValidElement(msg.content) &&
                            (msg.content.cover_image_list !== undefined || (msg.content.color !== undefined && msg.content.style !== undefined)) &&
                            msg.content.ongoing_status &&
                            msg.content.ongoing_status !== '3' &&
                            msg.content.ongoing_status !== '2') || // 🔥 新增：跳过失败状态
                        // 检查apiData中的数据
                        (msg.apiData &&
                            (msg.apiData.catalogs !== undefined ||
                                msg.apiData.title !== undefined ||
                                msg.apiData.cover_image_list !== undefined ||
                                (msg.apiData.color !== undefined && msg.apiData.style !== undefined)) &&
                            msg.apiData.ongoing_status &&
                            msg.apiData.ongoing_status !== '3' &&
                            msg.apiData.ongoing_status !== '2'); // 🔥 新增：跳过失败状态

                    if (shouldMarkCompleted) {
                        // 🔥 处理React组件消息
                        if (React.isValidElement(msg.content)) {
                            // 🔥 获取原始props并更新historyData
                            const originalProps = msg.content.props || {};
                            const updatedHistoryData = originalProps.historyData
                                ? {
                                      ...originalProps.historyData,
                                      ongoing_status: '3'
                                  }
                                : null;

                            // 🔥 克隆React元素并修改其props
                            const clonedContent = React.cloneElement(msg.content, {
                                ...originalProps,
                                ongoing_status: '3',
                                isCompleted: true,
                                ...(updatedHistoryData && { historyData: updatedHistoryData })
                            });

                            // 🔥 同时更新apiData中的ongoing_status
                            const updatedApiData = msg.apiData
                                ? {
                                      ...msg.apiData,
                                      ongoing_status: '3'
                                  }
                                : undefined;
                            return {
                                ...msg,
                                content: clonedContent,
                                apiData: updatedApiData,
                                isCompleted: true // 🔥 标记为已完成，让渲染逻辑处理
                            };
                        }
                        // 🔥 处理普通对象消息
                        else if (msg.content && typeof msg.content === 'object' && !React.isValidElement(msg.content)) {
                            return {
                                ...msg,
                                content: {
                                    ...msg.content,
                                    ongoing_status: '3'
                                }
                            };
                        }
                        // 🔥 处理apiData消息
                        else if (msg.apiData) {
                            return {
                                ...msg,
                                apiData: {
                                    ...msg.apiData,
                                    ongoing_status: '3'
                                },
                                isCompleted: true
                            };
                        }
                        // 🔥 其他情况，直接标记为完成
                        else {
                            return {
                                ...msg,
                                isCompleted: true
                            };
                        }
                    }
                    return msg;
                });

                // 🔥 修复：确保所有数据源都得到更新
                if (effectiveSessionId && originMsgMapRef) {
                    if (!originMsgMapRef?.[effectiveSessionId]) {
                        originMsgMapRef[effectiveSessionId] = {};
                    }
                    originMsgMapRef[effectiveSessionId].messages = [...(originMsgMapRef[effectiveSessionId].messages || []), ...updatedMessages];
                }

                if (effectiveSessionId && sessionMap[effectiveSessionId] && changeSessionMapItem && typeof changeSessionMapItem === 'function') {
                    try {
                        changeSessionMapItem(
                            effectiveSessionId,
                            {
                                messages: updatedMessages
                            },
                            updatedMessages
                        );
                    } catch (error) {
                        console.error('🔥 changeSessionMapItem调用失败:', error);
                    }
                }
                // 更新本地消息状态
                debugSetMessages(originMsgMapRef[effectiveSessionId].messages, 'markAllHistoryAsCompleted');
            };

            // 执行历史消息状态更新
            markAllHistoryAsCompleted();

            // 🔥 新增：会话创建和管理逻辑（模仿useChat.js）
            let currentSessionId = sessionId;
            const isNewSession = !currentSessionId || currentSessionId === 0;
            let sessionKey = null;
            let fakeSessionId = null;

            if (isNewSession) {
                // 新会话逻辑，生成假的session_id用于立即跳转
                // 🔥 修复：生成类似 1968552394295869440 格式的数字ID
                const timestamp = Date.now();
                const randomSuffix = Math.floor(Math.random() * 10000); // 4位随机数
                fakeSessionId = `${timestamp}${randomSuffix.toString().padStart(4, '0')}`;

                // 🔥 步骤1：先创建假的会话项并添加到会话列表顶部

                if (formatSessionList && typeof formatSessionList === 'function' && sessionListRef) {
                    // 创建假的会话数据，格式参考useChat.js中的逻辑
                    // 🔥 修复：添加 handler_json 字段，确保技能类型不丢失
                    const handler = curSkill?.third_json?.handler || 'aippt';
                    const fakeSessionData = {
                        session_name: `${message.substring(0, 20)}${message.length > 20 ? '...' : ''}`, // 使用消息前20个字符作为会话名
                        time_range: '1',
                        session_id: fakeSessionId,
                        skill_id: curSkill?.ability_id || skillId || '1957685884025380865',
                        handler_json: [handler], // 🔥 添加 handler_json，确保跳转后技能类型正确
                        fake: true // 标记为假会话，便于后续替换
                    };

                    // 获取当前会话列表，将假会话添加到顶部
                    const currentList = sessionListRef.current ? sessionListRef.current : [];
                    const newList = [fakeSessionData, ...currentList];

                    // 更新会话列表
                    formatSessionList(newList);
                }

                // 创建用户消息和AI占位符 - 使用与历史记录一致的格式
                const userMessage = {
                    _id: 'user_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9),
                    agent_id: agentId || currentAgent?.agent_id || '1957681408981704706',
                    content: {
                        ongoing_status: '1',
                        theme: message
                    },
                    content_type: 'aippt_theme',
                    create_time: new Date().toISOString().replace('T', ' ').substr(0, 19),
                    deleted: 0,
                    handler: 'aippt',
                    message_type: 'question',
                    metadata_json: {},
                    plugin_json: curPlugin || { deep_think: false, web_search: false },
                    reply_id: '0',
                    role: 'user',
                    section_id: fakeSessionId + '_section',
                    session_id: fakeSessionId,
                    skill_id: curSkill?.ability_id || skillId || '1957685884025380865',
                    tenant_id: '1704384780671352833',
                    update_time: new Date().toISOString().replace('T', ' ').substr(0, 19),
                    user_id: 'userId',
                    timestamp: Date.now()
                };

                const aiPlaceholder = {
                    id: 'ai_placeholder_' + Date.now(),
                    role: 'assistant',
                    content: (
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: '12px',
                                margin: '8px 0'
                            }}
                        >
                            <DotsLoading />
                        </div>
                    ),
                    loading: true,
                    status: 'loading',
                    timestamp: Date.now()
                };

                // 🔥 步骤2：先更新 sessionMap，然后跳转
                if (linkToSession && typeof linkToSession === 'function') {
                    // 🔥 使用 changeSessionMapItem 来正确添加消息到 sessionMap
                    if (changeSessionMapItem && typeof changeSessionMapItem === 'function') {
                        try {
                            changeSessionMapItem(
                                fakeSessionId,
                                {
                                    messages: [userMessage, aiPlaceholder]
                                },
                                [userMessage, aiPlaceholder]
                            );
                        } catch (error) {
                            console.error('🔥 新会话changeSessionMapItem调用失败:', error);
                        }
                    }

                    linkToSession(fakeSessionId, { replace: true });
                }

                // API请求时使用session_id=0，让后端创建新会话
                currentSessionId = '0';
                // 生成临时会话密钥用于前端跟踪
                sessionKey = 'aippt_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
            } else {
                // 已有会话，直接添加消息到本地状态 - 使用与历史记录一致的格式
                const userMessage = {
                    _id: 'user_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9),
                    agent_id: agentId || currentAgent?.agent_id || '1957681408981704706',
                    content: {
                        ongoing_status: '1',
                        theme: message
                    },
                    content_type: 'aippt_theme',
                    create_time: new Date().toISOString().replace('T', ' ').substr(0, 19),
                    deleted: 0,
                    handler: 'aippt',
                    message_type: 'question',
                    metadata_json: {},
                    plugin_json: curPlugin || { deep_think: false, web_search: false },
                    reply_id: '0',
                    role: 'user',
                    section_id: (sessionId || 'temp') + '_section',
                    session_id: sessionId ? Number(sessionId) : '0',
                    skill_id: curSkill?.ability_id || skillId || '1957685884025380865',
                    tenant_id: '1704384780671352833',
                    update_time: new Date().toISOString().replace('T', ' ').substr(0, 19),
                    user_id: 'userId',
                    timestamp: Date.now()
                };

                const loadingMessage = {
                    role: 'assistant',
                    content: (
                        <div
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: '12px',
                                margin: '8px 0'
                            }}
                        >
                            <DotsLoading />
                        </div>
                    ),
                    loading: true,
                    status: 'loading',
                    timestamp: Date.now()
                };

                // 🔥 修复：先构建完整的消息数组，然后同步更新所有状态
                const effectiveSessionId = localStorage.getItem('aippt_prev_session_id') || sessionId;

                // 🔥 优先从originMsgMapRef获取最新数据
                let currentMessages = [];
                if (effectiveSessionId && originMsgMapRef[effectiveSessionId].messages) {
                    currentMessages = [...originMsgMapRef[effectiveSessionId].messages];
                }

                const newMessages = [...currentMessages, userMessage, loadingMessage];

                // 🔥 立即同步到sessionMap，确保消息能立即显示
                if (effectiveSessionId && changeSessionMapItem && typeof changeSessionMapItem === 'function') {
                    try {
                        changeSessionMapItem(
                            effectiveSessionId,
                            {
                                messages: newMessages
                            },
                            newMessages
                        );
                    } catch (error) {
                        console.error('🔥 已有会话sessionMap同步失败:', error);
                    }
                }

                // 🔥 注释：originMsgMapRef 是用来获取最新数据的，不需要手动设置

                // 🔥 最后更新本地状态
                debugSetMessages(newMessages);

                // 🔥 同步到父组件的聊天数据（如果需要）
                if (handleMessages) {
                    const syncUserMessage = {
                        role: 'user',
                        content: message,
                        timestamp: Date.now()
                    };
                    const syncLoadingMessage = {
                        role: 'assistant',
                        content: (
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    borderRadius: '12px',
                                    margin: '8px 0'
                                }}
                            >
                                <DotsLoading />
                            </div>
                        ),
                        timestamp: Date.now(),
                        loading: true,
                        status: 'loading'
                    };
                    // 🔥 使用sessionId或临时ID进行同步
                    const syncSessionId = sessionId || 'temp-aippt-session';
                    handleMessages(newMessages, syncSessionId);
                }
            }

            // 获取用户ID
            const userId = getUserId();

            // 构建API请求参数
            const requestData = {
                user_id: userId,
                agent_id: agentId || currentAgent?.agent_id || '1957681408981704706', // 优先使用传入的agentId
                session_id: currentSessionId, // 🔥 新会话时为0，已有会话时使用实际ID
                skill_id: curSkill?.ability_id || skillId || '1957685884025380865', // 使用当前技能ID或默认AIPPT技能ID
                skill_name: curSkill?.name || 'AI PPT',
                skill_describe: curSkill?.description || '',
                apart: curSkill?.apart !== undefined ? curSkill?.apart : true, // 隔离技能
                question: {
                    theme: message // 用户输入的PPT主题
                },
                file_json: agentFile || [], // 使用传入的文件或空数组
                plugin_json: {
                    deep_think: curPlugin?.deep_think || false,
                    web_search: curPlugin?.web_search || false
                },
                // 🔥 新增：新会话时传递session_key
                ...(isNewSession && sessionKey ? { session_key: sessionKey } : {})
            };

            // 调用AI PPT接口
            const response = await handleAIPPTChat(requestData);

            // 🔥 修改：优先检查接口返回的错误状态
            if (!response || response.success === false || response.code === '400' || response.code === 400) {
                // 直接抛出错误，显示失败信息
                throw new Error(response?.msg || '生成失败，请重试');
            }

            // 处理接口响应
            if (response && response.data) {
                const responseData = response.data;

                // 🔥 新增：处理后端返回的会话ID（会话创建逻辑）
                let finalSessionId = currentSessionId;
                if (responseData.session_id && responseData.session_id !== currentSessionId) {
                    finalSessionId = responseData.session_id;

                    // 🔥 保存假会话ID和真实会话ID的映射关系，稍后统一处理数据迁移
                }

                // 创建大纲组件，直接传递完整的API响应数据
                const outlineComponent = (
                    <AIPPTExample
                        apiData={{
                            success: true,
                            data: responseData
                        }}
                        onGenerate={handleGenerateClick}
                        // 🔥 传入会话相关参数，使用最终的session_id
                        agentId={agentId || currentAgent?.agent_id || '1957681408981704706'}
                        sessionId={finalSessionId} // 使用最终确定的session_id
                        skillId={curSkill?.ability_id || skillId || '1957685884025380865'}
                        curSkill={curSkill}
                        conversationId={conversationId}
                        sessionMap={sessionMap}
                        curPlugin={curPlugin}
                        getItem={getItem} // 🔥 传递getItem方法
                    />
                );

                // 移除加载消息，添加AI回复消息（包含大纲组件）
                const aiMessage = {
                    role: 'assistant',
                    content: outlineComponent,
                    messageType: 'outline_editor', // 🔥 新增：标识这是大纲编辑器消息
                    sessionId: finalSessionId, // 🔥 保存会话ID到消息中
                    timestamp: Date.now()
                };

                // 🔥 新增：如果使用了假会话，需要替换为真实会话
                if (isNewSession && fakeSessionId && finalSessionId !== currentSessionId) {
                    // 🔥 关键修复：检查用户是否还在当前假会话页面
                    const currentUrlSessionId = window.location.pathname.split('/').pop();

                    if (currentUrlSessionId === fakeSessionId) {
                        // 用户还在假会话页面，执行数据迁移和URL更新

                        // 1️⃣ 静默更新URL（不触发页面跳转）
                        const newPath = window.location.pathname.replace(fakeSessionId, finalSessionId);
                        window.history.replaceState(null, '', newPath + searchStr);

                        // 2️⃣ 更新localStorage中的会话ID
                        localStorage.setItem('aippt_prev_session_id', finalSessionId);

                        // 3️⃣ 准备要迁移的消息数据
                        let messagesToMigrate = [];

                        // 优先从originMsgMapRef获取消息
                        if (originMsgMapRef?.current?.[fakeSessionId]?.messages) {
                            messagesToMigrate = [...originMsgMapRef.current[fakeSessionId].messages];
                        }
                        // 如果originMsgMapRef没有，从sessionMap获取
                        else if (sessionMap[fakeSessionId]?.messages) {
                            messagesToMigrate = [...sessionMap[fakeSessionId].messages];
                        }

                        // 4️⃣ 替换最后一个加载消息为真实的AI回复
                        if (messagesToMigrate.length > 0 && messagesToMigrate[messagesToMigrate.length - 1].loading) {
                            messagesToMigrate[messagesToMigrate.length - 1] = aiMessage;
                        } else {
                            // 如果没有加载消息，直接添加AI回复
                            messagesToMigrate.push(aiMessage);
                        }

                        // 5️⃣ 迁移originMsgMapRef中的数据到真实会话ID
                        if (originMsgMapRef?.current) {
                            if (originMsgMapRef.current[fakeSessionId]) {
                                originMsgMapRef.current[finalSessionId] = {
                                    ...originMsgMapRef.current[fakeSessionId],
                                    messages: messagesToMigrate
                                };
                                delete originMsgMapRef.current[fakeSessionId];
                            } else {
                                // 如果假会话没有数据，直接创建真实会话数据
                                originMsgMapRef.current[finalSessionId] = {
                                    messages: messagesToMigrate
                                };
                            }
                        }

                        // 6️⃣ 使用changeSessionMapItem来正确设置真实会话的数据
                        if (changeSessionMapItem && typeof changeSessionMapItem === 'function') {
                            try {
                                changeSessionMapItem(
                                    finalSessionId,
                                    {
                                        messages: messagesToMigrate,
                                        loading: false,
                                        answering: false
                                    },
                                    messagesToMigrate
                                );
                            } catch (error) {
                                console.error('🔥 设置真实会话数据失败:', error);
                            }
                        }

                        // 7️⃣ 删除假会话数据
                        if (sessionMap[fakeSessionId]) {
                            delete sessionMap[fakeSessionId];
                        }

                        // 8️⃣ 同步更新本地消息状态
                        setMessages(messagesToMigrate);

                        // 9️⃣ 更新会话列表
                        if (getHistorySessionList && typeof getHistorySessionList === 'function') {
                            try {
                                setTimeout(() => {
                                    getHistorySessionList();
                                }, 500); // 稍微延迟确保后端数据已更新
                            } catch (error) {
                                console.error('🔥 替换假会话失败:', error);
                            }
                        }

                        // 如果当前仍在该页面，通知上层切换到真实会话（更新侧边栏高亮等）
                        if (linkToSession && typeof linkToSession === 'function') {
                            try {
                                linkToSession(finalSessionId, { replace: true });
                            } catch (e) {
                                console.error('🔥 linkToSession 切换真实会话失败:', e);
                            }
                        }

                        // 广播会话切换事件，供其他组件监听（兼容）
                        try {
                            window.dispatchEvent(
                                new CustomEvent('session-switched', {
                                    detail: {
                                        sessionId: finalSessionId,
                                        skillId: curSkill?.ability_id || skillId
                                    }
                                })
                            );
                        } catch (e) {
                            /* ignore */
                        }
                    } else {
                        // 用户已经离开假会话页面，只做数据迁移，不更新URL和当前页面状态

                        // 1️⃣ 准备要迁移的消息数据
                        let messagesToMigrate = [];

                        // 优先从originMsgMapRef获取消息
                        if (originMsgMapRef?.current?.[fakeSessionId]?.messages) {
                            messagesToMigrate = [...originMsgMapRef.current[fakeSessionId].messages];
                        }
                        // 如果originMsgMapRef没有，从sessionMap获取
                        else if (sessionMap[fakeSessionId]?.messages) {
                            messagesToMigrate = [...sessionMap[fakeSessionId].messages];
                        }

                        // 2️⃣ 替换最后一个加载消息为真实的AI回复
                        if (messagesToMigrate.length > 0 && messagesToMigrate[messagesToMigrate.length - 1].loading) {
                            messagesToMigrate[messagesToMigrate.length - 1] = aiMessage;
                        } else {
                            // 如果没有加载消息，直接添加AI回复
                            messagesToMigrate.push(aiMessage);
                        }

                        // 3️⃣ 迁移originMsgMapRef中的数据到真实会话ID
                        if (originMsgMapRef?.current) {
                            if (originMsgMapRef.current[fakeSessionId]) {
                                originMsgMapRef.current[finalSessionId] = {
                                    ...originMsgMapRef.current[fakeSessionId],
                                    messages: messagesToMigrate
                                };
                                delete originMsgMapRef.current[fakeSessionId];
                            } else {
                                // 如果假会话没有数据，直接创建真实会话数据
                                originMsgMapRef.current[finalSessionId] = {
                                    messages: messagesToMigrate
                                };
                            }
                        }

                        // 4️⃣ 使用changeSessionMapItem来正确设置真实会话的数据
                        if (changeSessionMapItem && typeof changeSessionMapItem === 'function') {
                            try {
                                changeSessionMapItem(
                                    finalSessionId,
                                    {
                                        messages: messagesToMigrate,
                                        loading: false,
                                        answering: false
                                    },
                                    messagesToMigrate
                                );
                            } catch (error) {
                                console.error('🔥 设置真实会话数据失败:', error);
                            }
                        }

                        // 5️⃣ 删除假会话数据
                        if (sessionMap[fakeSessionId]) {
                            delete sessionMap[fakeSessionId];
                        }

                        // 6️⃣ 更新会话列表（关键！让假会话消失，真会话出现）
                        if (getHistorySessionList && typeof getHistorySessionList === 'function') {
                            try {
                                setTimeout(() => {
                                    getHistorySessionList();
                                }, 500); // 稍微延迟确保后端数据已更新
                            } catch (error) {
                                console.error('🔥 更新会话列表失败:', error);
                            }
                        }

                        // ❌ 不更新URL（用户不在这个页面）
                        // ❌ 不更新本地消息状态（用户不在这个页面）
                    }
                } else {
                    // 🔥 非新会话或没有假会话时的常规更新
                    // 🔥 修复：从originMsgMapRef获取最新数据，而不是使用prev
                    const effectiveSessionId = localStorage.getItem('aippt_prev_session_id') || finalSessionId;
                    let currentMessages = [];

                    // 优先从originMsgMapRef获取最新数据
                    if (effectiveSessionId && originMsgMapRef[effectiveSessionId].messages) {
                        currentMessages = [...originMsgMapRef[effectiveSessionId].messages];
                    }

                    // 移除最后一个加载消息，添加AI回复
                    if (currentMessages.length > 0 && currentMessages[currentMessages.length - 1].loading) {
                        currentMessages.pop(); // 移除加载消息
                    }
                    if (
                        currentMessages[currentMessages.length - 1].content_type === 'aippt_catalog' &&
                        currentMessages[currentMessages.length - 1].content.ongoing_status === '0'
                    ) {
                        currentMessages.pop();
                    }
                    currentMessages.push(aiMessage);

                    // 🔥 立即同步到sessionMap，避免被useEffect覆盖
                    if (finalSessionId && changeSessionMapItem && typeof changeSessionMapItem === 'function') {
                        try {
                            changeSessionMapItem(
                                finalSessionId,
                                {
                                    messages: currentMessages
                                },
                                currentMessages
                            );
                        } catch (error) {
                            console.error('🔥 已有会话sessionMap同步失败:', error);
                        }
                    }

                    // 🔥 注释：originMsgMapRef 是用来获取最新数据的，不需要手动设置

                    // 更新本地状态
                    setMessages(currentMessages);

                    if (getHistorySessionList && typeof getHistorySessionList === 'function') {
                        try {
                            setTimeout(() => {
                                getHistorySessionList();
                            }, 1000); // 延迟1秒确保后端数据已更新
                        } catch (error) {
                            console.error('🔥 更新AIPPT会话列表失败:', error);
                        }
                    }
                }
            } else {
                // 🔥 新增：处理API返回错误的情况
                if (response && response.success === false) {
                    throw new Error(response.msg || '生成失败，请重试');
                } else {
                    throw new Error('接口返回数据格式错误');
                }
            }
        } catch (error) {
            console.error('AI PPT生成失败:', error);

            // 🔥 使用replaceLoadingMessage函数正确地替换加载消息为错误消息
            replaceLoadingMessage(
                <div style={{ color: '#ff4d4f', padding: '12px 0', textAlign: 'center' }}>{error.message || '生成失败，请重试'}</div>,
                {
                    findPattern: (msg) => {
                        // 查找加载消息
                        return (
                            msg.loading === true ||
                            (msg.content && React.isValidElement(msg.content) && msg.content.type === DotsLoading) ||
                            (typeof msg.content === 'string' && msg.content.includes('正在生成'))
                        );
                    },
                    messageProps: {
                        error: true,
                        timestamp: Date.now()
                    },
                    syncToSessionMap: true
                }
            );
        } finally {
            setAipptLoading(false);

            // 🔥 新增：派发AIPPT加载完成事件
            window.dispatchEvent(
                new CustomEvent('aippt-loading-complete', {
                    detail: {
                        sessionId: sessionId,
                        timestamp: Date.now()
                    }
                })
            );
        }
    };

    // 处理生成按钮点击 - 在聊天中显示模板选择器
    const handleGenerateClick = async (data) => {
        // 🔥 在函数顶部定义requestId，确保在所有分支中都可用
        let requestId = null;

        if (data.type === 'loading') {
            // 🔥 设置API请求状态
            requestId = 'cover_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
            setApiRequestStatus({
                isPending: true,
                requestId: requestId,
                requestType: 'cover',
                startTime: Date.now()
            });

            // 🔥 新增：派发AIPPT加载开始事件，确保WebSender显示暂停图标
            const currentSessionId = localStorage.getItem('aippt_prev_session_id') || sessionId;
            window.dispatchEvent(
                new CustomEvent('aippt-loading-start', {
                    detail: {
                        sessionId: currentSessionId,
                        timestamp: Date.now(),
                        type: 'generate' // 标记为生成类型的加载
                    }
                })
            );

            const loadingId = Date.now();
            const loadingMessage = {
                role: 'assistant',
                content: (
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            borderRadius: '12px',
                            margin: '8px 0'
                        }}
                    >
                        <DotsLoading />
                    </div>
                ),
                loading: true,
                loadingId: loadingId, // 🔥 添加唯一ID，便于精确查找
                requestId: requestId, // 🔥 关联API请求ID
                timestamp: Date.now()
            };

            // 🔥 获取有效的sessionId - 如果sessionId为undefined，从sessionMap中获取
            let effectiveSessionId = localStorage.getItem('aippt_prev_session_id');

            // 🔥 修复：确保有基础消息数组来添加加载消息
            let baseMessages = [];

            // 🔥 修复：优先从originMsgMapRef获取最新数据
            if (effectiveSessionId && originMsgMapRef?.current?.[effectiveSessionId]?.messages) {
                baseMessages = [...originMsgMapRef.current[effectiveSessionId].messages];
            } else if (effectiveSessionId && sessionMap[effectiveSessionId]?.messages) {
                baseMessages = [...sessionMap[effectiveSessionId].messages];
            }

            // 🔥 创建包含加载消息的新消息数组
            const newMessagesWithLoading = [...baseMessages, loadingMessage];
            // 🔥 修复：更新本地状态
            debugSetMessages(newMessagesWithLoading);

            // 🔥 新增：同时更新 originMsgMapRef，确保数据一致性
            const eid = localStorage.getItem('aippt_prev_session_id');
            if (eid && originMsgMapRef.current) {
                if (!originMsgMapRef.current[eid]) {
                    originMsgMapRef.current[eid] = {};
                }
                originMsgMapRef.current[eid].messages = newMessagesWithLoading;
            }

            // 🔥 立即同步到sessionMap，避免延迟导致的状态竞争
            if (eid && changeSessionMapItem && typeof changeSessionMapItem === 'function') {
                try {
                    changeSessionMapItem(
                        eid,
                        {
                            messages: newMessagesWithLoading
                        },
                        newMessagesWithLoading
                    );
                } catch (error) {
                    console.error('🔥 changeSessionMapItem调用失败:', error);
                }
            }

            return;
        }

        if (data.type === 'template' && data.coverResponse) {
            // 🔥 根据接口返回数据获取默认选中状态
            const { defaultColor, defaultStyle } = getDefaultSelectionFromResponse(data.coverResponse);

            // 🔥 修复：优先使用 coverResponse 中的 _id 作为 recordId，确保与后续点击时使用的 recordId 一致
            // 🔥 如果没有 _id，则使用 getCurrentRecordInfo() 作为降级方案
            const currentRecordId = data.coverResponse._id || getCurrentRecordInfo()?.recordId || 'default';

            // 创建模板选择器组件
            const templateSelectorComponent = (
                <TemplateSelector
                    templates={[]}
                    colorOptions={colorOptions}
                    styleOptions={styleOptions}
                    selectedTemplate={selectedTemplate}
                    selectedColor={defaultColor}
                    selectedStyle={defaultStyle}
                    onColorSelect={handleColorSelect}
                    onStyleSelect={handleStyleSelect}
                    onConfirm={handleTemplateSelect}
                    historyData={data.coverResponse}
                    isHistoryMode={true}
                    recordId={currentRecordId}
                    loadingCovers={loadingCovers}
                    message={null}
                    chatHistory={[]}
                    isCompleted={false} // 🔥 新增：新创建的模板选择器不是完成状态
                />
            );

            // 🔥 使用更灵活的查找模式来替换加载消息，使用保存的sessionId
            const targetSessionId = loadingMessageSessionId || sessionId;

            // 🔥 获取正确的requestId - 优先从加载消息中查找，其次使用apiRequestStatus
            let currentRequestId = null;

            // 🔥 尝试从当前消息中找到最近的加载消息的requestId
            const eid = localStorage.getItem('aippt_prev_session_id');
            let currentMessages = [];
            if (eid && originMsgMapRef?.current?.[eid]?.messages) {
                currentMessages = originMsgMapRef.current[eid].messages;
            } else if (eid && sessionMap[eid]?.messages) {
                currentMessages = sessionMap[eid].messages;
            }

            // 🔥 从后往前查找最近的加载消息
            for (let i = currentMessages.length - 1; i >= 0; i--) {
                const msg = currentMessages[i];
                if (msg.loading === true && msg.requestId) {
                    currentRequestId = msg.requestId;
                    break;
                }
            }

            // 🔥 如果没找到，使用apiRequestStatus中的requestId
            if (!currentRequestId && apiRequestStatus.requestId) {
                currentRequestId = apiRequestStatus.requestId;
            }

            const replaceResult = replaceLoadingMessage(templateSelectorComponent, {
                sessionId: targetSessionId, // 🔥 使用保存的sessionId
                syncToSessionMap: true, // 🔥 启用同步到sessionMap，确保模板选择器能显示
                findPattern: (msg) => {
                    // 🔥 首先检查loading属性（最可靠的判断）
                    if (msg.loading === true) {
                        return true;
                    }

                    // 🔥 检查requestId匹配（使用当前请求的requestId）
                    if (msg.requestId && currentRequestId && msg.requestId === currentRequestId) {
                        return true;
                    }

                    // 🔥 检查loadingId匹配
                    if (msg.loadingId) {
                        return true;
                    }

                    // 🔥 新增：检查ongoing_status为"0"或status为2的消息（表示生成完成，需要显示模板选择器）
                    if (msg.content && typeof msg.content === 'object') {
                        // 检查 ongoing_status 为 "0" 的旧格式
                        if (msg.content.ongoing_status === '0' && (msg.content_type === 'aippt_cover' || msg.content_type === 'aippt_result')) {
                            return true;
                        }
                    }

                    // 🔥 安全地检查消息内容是否包含加载相关文本或DotsLoading组件
                    if (msg.content && React.isValidElement(msg.content)) {
                        try {
                            // 🔥 检查是否包含DotsLoading组件
                            const checkForDotsLoading = (element) => {
                                if (!element || !element.props) return false;

                                // 检查子元素
                                if (element.props.children) {
                                    if (React.isValidElement(element.props.children)) {
                                        if (element.props.children.type === DotsLoading) {
                                            return true;
                                        }
                                        return checkForDotsLoading(element.props.children);
                                    }
                                    if (Array.isArray(element.props.children)) {
                                        return element.props.children.some(
                                            (child) => React.isValidElement(child) && (child.type === DotsLoading || checkForDotsLoading(child))
                                        );
                                    }
                                }
                                return false;
                            };

                            if (checkForDotsLoading(msg.content)) {
                                return true;
                            }

                            // 🔥 使用更安全的方式检查React组件内容
                            const props = msg.content.props;
                            if (props && typeof props === 'object') {
                                // 检查 props 中是否包含相关文本
                                const propsStr =
                                    Object.keys(props).join(' ') +
                                    ' ' +
                                    Object.values(props)
                                        .filter((v) => typeof v === 'string')
                                        .join(' ');
                                // 🔥 修复：匹配实际的加载消息文本
                                if (
                                    propsStr.includes('正在生成AI PPT大纲') ||
                                    propsStr.includes('正在生成PPT大纲') ||
                                    propsStr.includes('正在为主题') ||
                                    propsStr.includes('生成PPT模板')
                                ) {
                                    return true;
                                }
                            }

                            // 检查组件类型
                            if (msg.content.type && typeof msg.content.type === 'string' && msg.content.type.includes('Loading')) {
                                return true;
                            }
                        } catch (error) {
                            console.error('🔥 检查React组件内容时出错，跳过:', error.message);
                        }
                    }

                    // 🔥 检查纯文本内容
                    if (
                        typeof msg.content === 'string' &&
                        (msg.content.includes('正在生成AI PPT大纲') ||
                            msg.content.includes('正在生成PPT大纲') ||
                            msg.content.includes('正在为主题') ||
                            msg.content.includes('生成PPT模板'))
                    ) {
                        return true;
                    }
                    return false;
                },
                messageProps: {
                    apiData: {
                        ...data.coverResponse,
                        _id: currentRecordId // 🔥 确保 apiData 中包含正确的 _id
                    },
                    messageType: 'template_selector',
                    _id: currentRecordId // 🔥 同时在消息级别保存 _id，确保 getCurrentRecordInfo 能正确获取
                }
            });

            const success = replaceResult?.success;
            const updatedMessages = replaceResult?.messages;

            if (success && updatedMessages) {
                const eid = localStorage.getItem('aippt_prev_session_id');

                // 🔥 验证updatedMessages中确实包含了模板选择器
                const hasTemplateSelector = updatedMessages.some(
                    (msg) =>
                        msg.messageType === 'template_selector' ||
                        (msg.content && React.isValidElement(msg.content) && msg.content.type && msg.content.type.name === 'TemplateSelector')
                );

                // 🔥 替换成功后，确保数据也保存到sessionMap中
                if (eid && changeSessionMapItem && typeof changeSessionMapItem === 'function') {
                    try {
                        // 使用replaceLoadingMessage返回的最新消息数组（包含模板组件的数组）
                        // 直接使用changeSessionMapItem保存当前状态
                        changeSessionMapItem(
                            eid,
                            {
                                messages: updatedMessages
                            },
                            updatedMessages
                        );

                        // 🔥 注释：originMsgMapRef 是用来获取最新数据的，不需要手动设置
                    } catch (error) {
                        console.error('🔥 保存模板选择器数据到sessionMap失败:', error);
                    }
                }
            } else {
                // 🔥 修复：如果替换失败，检查失败原因，避免重复添加
                if (replaceResult?.reason === 'duplicate_component') {
                    return;
                }

                // 🔥 如果替换失败且不是因为重复组件，直接添加模板选择器到消息列表
                const eid = localStorage.getItem('aippt_prev_session_id');

                if (eid && changeSessionMapItem && typeof changeSessionMapItem === 'function') {
                    try {
                        // 🔥 修复：从originMsgMapRef获取最新消息，确保数据一致性
                        let currentMessages = [];
                        if (originMsgMapRef?.current?.[eid]?.messages) {
                            currentMessages = [...originMsgMapRef.current[eid].messages];
                        } else if (sessionMap[eid]?.messages) {
                            currentMessages = [...sessionMap[eid].messages];
                        }

                        // 🔥 新增：检查是否已经存在模板选择器，避免重复添加
                        const hasTemplateSelector = currentMessages.some(
                            (msg) =>
                                msg.messageType === 'template_selector' ||
                                (React.isValidElement(msg.content) && msg.content.type && msg.content.type.name === 'TemplateSelector') ||
                                // 🔥 检查是否有ongoing_status为"0"的消息已经被处理
                                (msg.content &&
                                    typeof msg.content === 'object' &&
                                    msg.content.ongoing_status === '0' &&
                                    msg.content_type === 'aippt_cover' &&
                                    React.isValidElement(msg.content))
                        );

                        if (hasTemplateSelector) {
                            return;
                        }

                        const newMessages = [
                            ...currentMessages,
                            {
                                id: `template_selector_${Date.now()}`,
                                role: 'assistant',
                                content: templateSelectorComponent,
                                messageType: 'template_selector',
                                apiData: data.coverResponse,
                                timestamp: Date.now()
                            }
                        ];

                        changeSessionMapItem(eid, {
                            messages: newMessages
                        });
                    } catch (error) {
                        console.error('🔥 直接添加模板选择器到sessionMap失败:', error);
                    }
                }
            }

            // 🔥 新增：派发AIPPT加载完成事件，让WebSender隐藏暂停图标
            const completeSessionId = localStorage.getItem('aippt_prev_session_id') || sessionId;
            window.dispatchEvent(
                new CustomEvent('aippt-loading-complete', {
                    detail: {
                        sessionId: completeSessionId,
                        timestamp: Date.now(),
                        type: 'template_ready' // 标记为模板就绪
                    }
                })
            );

            return;
        }
    };

    // 处理模板选择
    const handleTemplateSelect = async (template) => {
        // 🔥 在 try 外部定义 loadingMessage，确保 catch 块可以访问
        const loadingMessage = {
            id: `ppt_generating_${Date.now()}`,
            role: 'assistant',
            content: (
                <div
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        borderRadius: '12px',
                        margin: '8px 0'
                    }}
                >
                    <DotsLoading />
                </div>
            ),
            loading: true,
            timestamp: Date.now()
        };

        try {
            setSelectedTemplate(template);

            // 🔥 新增：派发AIPPT加载开始事件
            window.dispatchEvent(
                new CustomEvent('aippt-loading-start', {
                    detail: {
                        sessionId: sessionId,
                        timestamp: Date.now()
                    }
                })
            );

            const eid = localStorage.getItem('aippt_prev_session_id');

            // 🔥 获取最新的消息状态 - 优先从originMsgMapRef获取，避免异步问题
            let currentMessages = [];
            if (eid) {
                // 优先从originMsgMapRef获取最新状态
                if (originMsgMapRef[eid]?.messages) {
                    currentMessages = originMsgMapRef[eid].messages;
                }
            }

            // 🔥 同步添加加载消息到sessionMap和本地状态
            const newMessagesWithLoading = [...currentMessages, loadingMessage];

            if (eid && changeSessionMapItem && typeof changeSessionMapItem === 'function') {
                try {
                    changeSessionMapItem(
                        eid,
                        {
                            messages: newMessagesWithLoading
                        },
                        newMessagesWithLoading
                    );
                } catch (error) {
                    console.error('🔥 同步加载消息到sessionMap失败:', error);
                }
            }

            // 🔥 修复：同时更新本地消息状态，确保消息立即显示且能被找到
            debugSetMessages(newMessagesWithLoading, 'handleTemplateSelect_addLoading');

            // 🔥 3. 获取记录信息（在sessionMap更新之后）
            let recordInfo = getCurrentRecordInfo();

            if (!recordInfo || !recordInfo.recordId) {
                // 如果无法获取记录信息，创建一个默认的记录信息
                console.warn('🔥 无法获取会话记录信息，使用默认值');
                const currentUserId = getUserId();
                recordInfo = {
                    recordId: 'temp_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9),
                    userId: currentUserId,
                    agentId: agentId || currentAgent?.agent_id || '1957681408981704706',
                    sessionId: sessionId || 'temp_session_' + Date.now(),
                    skillId: curSkill?.ability_id || skillId || '1957685884025380865',
                    skillName: curSkill?.name || 'AI PPT生成',
                    skillDescribe: curSkill?.description || '智能PPT生成助手',
                    apart: curSkill?.apart !== undefined ? curSkill?.apart : true,
                    sessionKey: 'aippt_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9),
                    originalQuestion: '生成PPT'
                };
            }

            // 🔥 4. 构建调用handleAIPPTCreate的请求数据
            const createData = {
                _id: recordInfo.recordId,
                user_id: recordInfo.userId,
                agent_id: recordInfo.agentId,
                session_id: recordInfo.sessionId,
                skill_id: recordInfo.skillId,
                skill_name: recordInfo.skillName,
                skill_describe: recordInfo.skillDescribe,
                apart: recordInfo.apart,
                character_setting: '这是一个智能体的角色设定',
                question: {
                    cover_id: template.template.cover_id // 🔥 传入选中的模板ID
                },
                file_json: [],
                plugin_json: {
                    deep_think: false,
                    web_search: false
                },
                session_key: recordInfo.sessionKey
            };

            // 🔥 5. 调用PPT创建API（第一步）
            const createResponse = await handleAIPPTCreate(createData);
            if (!createResponse?.success || !createResponse?.data?.id) {
                throw new Error(createResponse?.msg || '生成失败，请重试');
            }

            // 🔥 6. 使用返回的ID调用PPT结果获取API（第二步）
            const resultData = {
                user_id: recordInfo.userId,
                agent_id: recordInfo.agentId,
                session_id: recordInfo.sessionId,
                skill_id: recordInfo.skillId,
                skill_name: recordInfo.skillName,
                skill_describe: recordInfo.skillDescribe,
                apart: recordInfo.apart,
                character_setting: '这是一个智能体的角色设定',
                question: {
                    ppt_id: createResponse.data.id // 🔥 使用第一步返回的ID
                },
                file_json: [],
                plugin_json: {
                    deep_think: false,
                    web_search: false
                },
                session_key: recordInfo.sessionKey
            };

            // 🔥 7. 开始轮询获取PPT生成结果
            const pollForResult = async () => {
                let attempts = 0;
                const maxAttempts = 60; // 最多轮询60次（10分钟）

                while (attempts < maxAttempts) {
                    try {
                        const resultResponse = await handleAIPPTResult(resultData);

                        if (!resultResponse?.success || !resultResponse?.data) {
                            throw new Error(resultResponse?.msg || '生成失败，请重试');
                        }

                        const status = resultResponse.data.status;

                        if (status === 2) {
                            // 🔥 状态为2表示已完成，显示ImageWithButtons组件

                            // 🔥 保存PPT ID，优先从resultResponse中获取
                            const pptId = resultResponse?.data?.id || resultResponse?.data?.ppt_id || createResponse?.data?.id;

                            // 🔥 创建结果内容
                            const resultContent = (
                                <ImageWithButtons
                                    imageUrl={resultResponse?.data?.images_url || template.preview || '/favicon.ico'}
                                    imageAlt={`PPT预览 - ${template.title || '模板'}`}
                                    buttonText1="编辑"
                                    buttonText2="下载"
                                    pptId={pptId} // 🔥 直接传递PPT ID给组件
                                    onButton1Click={() => {
                                        // 调用编辑PPT接口，优先使用组件中保存的pptId
                                        handleAIPPTEditorClick(pptId || resultResponse?.data);
                                    }}
                                    onButton2Click={() => {
                                        // 调用下载PPT接口，优先使用组件中保存的pptId
                                        handleAIPPTDownloadClick(pptId || resultResponse?.data);
                                    }}
                                />
                            );

                            const replaceResult = replaceLoadingMessage(resultContent, {
                                findPattern: (msg) => {
                                    // 🔥 修复：更精确的查找模式，优先匹配ID，然后匹配loading状态
                                    // 检查 status 为 2 的新格式
                                    if (msg.content.ongoing_status === '0' && msg.content_type === 'aippt_result') {
                                        return true;
                                    }

                                    // 🔥 修复：检查是否为PPT生成的加载消息
                                    if (msg.loading === true) {
                                        // 进一步检查是否为PPT生成相关的加载消息
                                        if (msg.id && msg.id.includes('ppt_generating')) {
                                            return true;
                                        }
                                        // 检查最近添加的加载消息（时间戳差异小于5分钟）
                                        if (msg.timestamp && Date.now() - msg.timestamp < 5 * 60 * 1000) {
                                            return true;
                                        }
                                    }

                                    return false;
                                },
                                messageProps: {
                                    // 🔥 保存原始PPT数据，供编辑功能使用
                                    pptData: resultResponse?.data, // 保存完整的PPT结果数据
                                    pptId: pptId, // 🔥 直接保存PPT ID到消息级别
                                    apiData: {
                                        createResponse: createResponse?.data, // 保存创建响应数据
                                        resultResponse: resultResponse?.data // 保存结果响应数据
                                    }
                                },
                                sessionId: eid,
                                syncToSessionMap: true
                            });

                            break; // 完成，退出轮询
                        } else if (status === 3) {
                            // 🔥 状态为3表示生成失败
                            throw new Error('生成失败，请重试');
                        } else if (status === 1) {
                            attempts++;
                            // 🔥 等待10秒后继续下一次轮询
                            await new Promise((resolve) => setTimeout(resolve, 10000));
                        } else {
                            // 🔥 未知状态
                            console.warn('🔥 未知的PPT生成状态:', status);
                            attempts++;
                            await new Promise((resolve) => setTimeout(resolve, 10000));
                        }
                    } catch (error) {
                        console.error(`🔥 PPT生成轮询第${attempts + 1}次失败:`, error);
                        attempts++;

                        if (attempts >= maxAttempts) {
                            throw error; // 达到最大尝试次数，抛出错误
                        }

                        // 等待10秒后重试
                        await new Promise((resolve) => setTimeout(resolve, 10000));
                    }
                }

                if (attempts >= maxAttempts) {
                    throw new Error('生成失败，请重试');
                }
            };

            // 🔥 开始轮询
            await pollForResult();
        } catch (error) {
            console.error('🔥 PPT生成失败:', error);

            // 🔥 错误时也要替换加载消息
            replaceLoadingMessage(<div>❌ {error.message || '生成失败，请重试'}</div>, {
                findPattern: (msg) => msg.id === loadingMessage.id || msg.loading === true,
                sessionId: localStorage.getItem('aippt_prev_session_id'),
                syncToSessionMap: true
            });
        } finally {
            // 🔥 无论成功还是失败，都要清除API请求状态
            setApiRequestStatus({
                isPending: false,
                requestId: null,
                requestType: null,
                startTime: null
            });

            // 🔥 新增：派发AIPPT加载完成事件
            window.dispatchEvent(
                new CustomEvent('aippt-loading-complete', {
                    detail: {
                        sessionId: sessionId,
                        timestamp: Date.now()
                    }
                })
            );
        }
    };

    // 🔥 获取当前记录信息的辅助函数
    const getCurrentRecordInfo = () => {
        // 🔥 优先从localStorage读取保存的apiData
        const savedApiData = localStorage.getItem('aippt_current_api_data');
        if (savedApiData) {
            try {
                const apiData = JSON.parse(savedApiData);

                const currentUserId = getUserId();
                const effectiveSessionId = localStorage.getItem('aippt_prev_session_id') || sessionId;

                // 🔥 尝试获取用户的原始问题
                let originalQuestion = '生成PPT';
                if (messages && Array.isArray(messages)) {
                    for (let i = messages.length - 1; i >= 0; i--) {
                        const msg = messages[i];
                        if (msg.role === 'user' && typeof msg.content === 'string') {
                            originalQuestion = msg.content;
                            break;
                        }
                    }
                }

                return {
                    recordId: apiData._id,
                    userId: apiData.user_id || currentUserId,
                    agentId: apiData.agent_id || agentId || currentAgent?.agent_id || '1957681408981704706',
                    sessionId: apiData.session_id || effectiveSessionId || sessionId,
                    skillId: apiData.skill_id || curSkill?.ability_id || skillId || '1957685884025380865',
                    skillName: curSkill?.name || '通用技能',
                    skillDescribe: curSkill?.description || '',
                    apart: curSkill?.apart !== undefined ? curSkill?.apart : true,
                    sessionKey: apiData.session_key || 'aippt_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9),
                    originalQuestion: originalQuestion
                };
            } catch (error) {
                console.error('🔥 解析localStorage中的apiData失败:', error);
            }
        }

        // 🔥 降级方案：从originMsgMapRef获取消息数据
        const currentUserId = getUserId();
        const effectiveSessionId = localStorage.getItem('aippt_prev_session_id');

        // 🔥 从originMsgMapRef获取消息数据
        const originSessionData = originMsgMapRef?.current?.[effectiveSessionId];
        let messagesArray = originSessionData?.messages || [];

        // 🔥 确保 messagesArray 是数组
        if (!Array.isArray(messagesArray)) {
            console.error('🔥 messagesArray 不是数组，类型:', typeof messagesArray, '值:', messagesArray);
            messagesArray = [];
        }

        // 🔥 遍历消息查找包含记录信息的消息
        for (let i = messagesArray.length - 1; i >= 0; i--) {
            const msg = messagesArray[i];

            if (msg.role === 'assistant') {
                // 🔥 优先检查apiData中的_id字段
                if (msg.apiData && msg.apiData._id) {
                    // 🔥 尝试获取用户的原始问题
                    let originalQuestion = '生成PPT';
                    for (let j = i - 1; j >= 0; j--) {
                        const userMsg = messagesArray[j];
                        if (userMsg.role === 'user' && typeof userMsg.content === 'string') {
                            originalQuestion = userMsg.content;
                            break;
                        }
                    }

                    return {
                        recordId: msg.apiData._id,
                        userId: msg.apiData.user_id || currentUserId,
                        agentId: msg.apiData.agent_id || agentId || currentAgent?.agent_id || '1957681408981704706',
                        sessionId: effectiveSessionId || msg.apiData.session_id || msg.sessionId || sessionId,
                        skillId: msg.apiData.skill_id || curSkill?.ability_id || skillId || '1957685884025380865',
                        skillName: curSkill?.name || '通用技能',
                        skillDescribe: curSkill?.description || '',
                        apart: curSkill?.apart !== undefined ? curSkill?.apart : true,
                        sessionKey: msg.apiData.session_key || 'aippt_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9),
                        originalQuestion: originalQuestion // 🔥 添加原始问题
                    };
                }

                // 🔥 检查是否为模板选择器消息（无论是否有_id）
                if (msg.messageType === 'template_selector' && msg.apiData) {
                    // 🔥 尝试获取用户的原始问题
                    let originalQuestion = '生成PPT';
                    for (let j = i - 1; j >= 0; j--) {
                        const userMsg = messagesArray[j];
                        if (userMsg.role === 'user' && typeof userMsg.content === 'string') {
                            originalQuestion = userMsg.content;
                            break;
                        }
                    }

                    // 🔥 使用apiData中的字段构建记录信息，优先使用_id
                    return {
                        recordId:
                            msg.apiData._id ||
                            msg.apiData.id ||
                            msg.apiRequestId ||
                            'temp_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9),
                        userId: msg.apiData.user_id || currentUserId,
                        agentId: msg.apiData.agent_id || agentId || currentAgent?.agent_id || '1957681408981704706',
                        sessionId: msg.apiData.session_id || msg.sessionId || sessionId,
                        skillId: msg.apiData.skill_id || curSkill?.ability_id || skillId || '1957685884025380865',
                        skillName: curSkill?.name || '通用技能',
                        skillDescribe: curSkill?.description || '',
                        apart: curSkill?.apart !== undefined ? curSkill?.apart : true,
                        sessionKey: msg.apiData.session_key || 'aippt_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9),
                        originalQuestion: originalQuestion
                    };
                }

                if (msg.content && typeof msg.content === 'object') {
                    // 检查是否有直接的_id字段
                    if (msg.content._id) {
                        // 🔥 尝试获取用户的原始问题
                        let originalQuestion = '生成PPT';
                        for (let j = i - 1; j >= 0; j--) {
                            const userMsg = messagesArray[j];
                            if (userMsg.role === 'user' && typeof userMsg.content === 'string') {
                                originalQuestion = userMsg.content;
                                break;
                            }
                        }

                        return {
                            recordId: msg.content._id,
                            userId: msg.content.user_id || currentUserId,
                            agentId: msg.content.agent_id || agentId || currentAgent?.agent_id || '1957681408981704706',
                            sessionId: msg.content.session_id || sessionId,
                            skillId: msg.content.skill_id || curSkill?.ability_id || skillId || '1957685884025380865',
                            skillName: curSkill?.name || '通用技能',
                            skillDescribe: curSkill?.description || '',
                            apart: curSkill?.apart !== undefined ? curSkill?.apart : true,
                            sessionKey: msg.content.session_key || 'aippt_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9),
                            originalQuestion: originalQuestion // 🔥 添加原始问题
                        };
                    }
                    // 检查是否为原始消息格式（直接包含_id字段）
                    else if (msg._id) {
                        // 🔥 尝试获取用户的原始问题
                        let originalQuestion = '生成PPT';
                        for (let j = i - 1; j >= 0; j--) {
                            const userMsg = messagesArray[j];
                            if (userMsg.role === 'user' && typeof userMsg.content === 'string') {
                                originalQuestion = userMsg.content;
                                break;
                            }
                        }

                        return {
                            recordId: msg._id,
                            userId: msg.user_id || currentUserId,
                            agentId: msg.agent_id || agentId || currentAgent?.agent_id || '1957681408981704706',
                            sessionId: msg.session_id || sessionId,
                            skillId: msg.skill_id || curSkill?.ability_id || skillId || '1957685884025380865',
                            skillName: curSkill?.name || '通用技能',
                            skillDescribe: curSkill?.description || '',
                            apart: curSkill?.apart !== undefined ? curSkill?.apart : true,
                            sessionKey: msg.session_key || 'aippt_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9),
                            originalQuestion: originalQuestion // 🔥 添加原始问题
                        };
                    }
                }
            }
        }

        // 如果本地消息中没有找到，尝试从sessionMap中查找
        if (sessionId && sessionMap?.[sessionId]?.messages) {
            for (let i = sessionMap[sessionId].messages.length - 1; i >= 0; i--) {
                const msg = sessionMap[sessionId].messages[i];
                if (msg.role === 'assistant' && msg.content && typeof msg.content === 'object') {
                    // 检查是否有直接的_id字段
                    if (msg.content._id) {
                        return {
                            recordId: msg.content._id,
                            userId: msg.content.user_id || currentUserId,
                            agentId: msg.content.agent_id || agentId || currentAgent?.agent_id || '1957681408981704706',
                            sessionId: msg.content.session_id || sessionId,
                            skillId: msg.content.skill_id || curSkill?.ability_id || skillId || '1957685884025380865',
                            skillName: curSkill?.name || '通用技能',
                            skillDescribe: curSkill?.description || '',
                            apart: curSkill?.apart !== undefined ? curSkill?.apart : true,
                            sessionKey: msg.content.session_key || 'aippt_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9)
                        };
                    }
                    // 检查是否为原始消息格式（直接包含_id字段）
                    else if (msg._id) {
                        return {
                            recordId: msg._id,
                            userId: msg.user_id || currentUserId,
                            agentId: msg.agent_id || agentId || currentAgent?.agent_id || '1957681408981704706',
                            sessionId: msg.session_id || sessionId,
                            skillId: msg.skill_id || curSkill?.ability_id || skillId || '1957685884025380865',
                            skillName: curSkill?.name || '通用技能',
                            skillDescribe: curSkill?.description || '',
                            apart: curSkill?.apart !== undefined ? curSkill?.apart : true,
                            sessionKey: msg.session_key || 'aippt_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9)
                        };
                    }
                }
            }
        }

        return null;
    };

    // 🔥 新增：处理编辑PPT的函数
    const handleAIPPTEditorClick = async (pptData) => {
        try {
            // 获取用户ID
            const userId = getUserId();

            // 🔥 智能提取PPT ID，支持多种数据结构
            let pptId = null;

            if (pptData) {
                // 优先级1: pptData.content.id (历史记录格式)
                if (pptData.content && pptData.content.id) {
                    pptId = pptData.content.id;
                }
                // 优先级2: pptData.id (直接ID字段)
                else if (pptData.id) {
                    pptId = pptData.id;
                }
                // 优先级3: pptData.ppt_id (标准字段名)
                else if (pptData.ppt_id) {
                    pptId = pptData.ppt_id;
                }
                // 优先级4: 如果pptData本身就是字符串ID
                else if (typeof pptData === 'string') {
                    pptId = pptData;
                }
            }

            if (!pptId) {
                throw new Error('无法获取PPT ID，请检查数据格式');
            }

            // 构建编辑PPT的请求数据
            const editorData = {
                user_id: userId,
                agent_id: agentId || currentAgent?.agent_id || '1957681408981704706',
                session_id: sessionId || 0,
                skill_id: curSkill?.ability_id || skillId || '1957685884025380865',
                skill_name: curSkill?.name || '通用技能',
                skill_describe: curSkill?.description || '',
                apart: curSkill?.apart !== undefined ? curSkill?.apart : true,
                character_setting: '这是一个智能体的角色设定',
                question: {
                    ppt_id: pptId // 使用智能提取的PPT ID
                },
                file_json: [],
                plugin_json: {
                    deep_think: false,
                    web_search: false
                },
                session_key: 'aippt_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9)
            };

            // 调用编辑PPT接口
            const response = await handleAIPPTEditor(editorData);

            if (response && (response.code === 200 || response.code === '200') && response.data && response.data.url) {
                // 成功获取编辑URL，跳转到新页面
                window.open(response.data.url, '_blank');
            } else {
                throw new Error(response?.msg || '获取编辑链接失败');
            }
        } catch (error) {
            console.error('🔥 编辑PPT失败:', error);
            // 显示错误提示
        }
    };

    // 🔥 新增：处理下载PPT的函数
    const handleAIPPTDownloadClick = async (pptData) => {
        try {
            // 获取用户ID
            const userId = getUserId();

            // 🔥 智能提取PPT ID，支持多种数据结构
            let pptId = null;

            if (pptData) {
                // 优先级1: pptData.content.id (历史记录格式)
                if (pptData.content && pptData.content.id) {
                    pptId = pptData.content.id;
                }
                // 优先级2: pptData.id (直接ID字段)
                else if (pptData.id) {
                    pptId = pptData.id;
                }
                // 优先级3: pptData.ppt_id (标准字段名)
                else if (pptData.ppt_id) {
                    pptId = pptData.ppt_id;
                }
                // 优先级4: 如果pptData本身就是字符串ID
                else if (typeof pptData === 'string') {
                    pptId = pptData;
                }
            }

            if (!pptId) {
                throw new Error('无法获取PPT ID，请检查数据格式');
            }

            // 构建下载PPT的请求数据
            const downloadData = {
                user_id: userId,
                agent_id: agentId || currentAgent?.agent_id || '1957681408981704706',
                session_id: sessionId || 0,
                skill_id: curSkill?.ability_id || skillId || '1957685884025380865',
                skill_name: curSkill?.name || '通用技能',
                skill_describe: curSkill?.description || '',
                apart: curSkill?.apart !== undefined ? curSkill?.apart : true,
                character_setting: '这是一个智能体的角色设定',
                question: {
                    ppt_id: pptId // 使用智能提取的PPT ID
                },
                file_json: [],
                plugin_json: {
                    deep_think: false,
                    web_search: false
                },
                session_key: 'aippt_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9)
            };

            // 调用下载PPT接口
            const response = await handleAIPPTDownload(downloadData);

            // 🔥 修复：支持多种API返回格式，优先检查download_url字段
            const downloadUrl = response?.data?.download_url || response?.data?.url;

            if (response && (response.code === 200 || response.code === '200' || response.success === true) && response.data && downloadUrl) {
                // 成功获取下载URL，直接下载文件

                // 创建一个临时的a标签来触发下载
                const downloadLink = document.createElement('a');
                downloadLink.href = downloadUrl;
                downloadLink.download = `AI_PPT_${pptId}.pptx`; // 设置下载文件名
                downloadLink.target = '_blank';

                // 添加到DOM并触发点击
                document.body.appendChild(downloadLink);
                downloadLink.click();

                // 清理临时元素
                document.body.removeChild(downloadLink);
            } else {
                console.error('🔥 API响应数据:', response);
                throw new Error(response?.msg || '获取下载链接失败，请检查API响应');
            }
        } catch (error) {
            console.error('🔥 下载PPT失败:', error);
            // 显示错误提示
            alert(`下载PPT失败: ${error.message || '未知错误'}`);
        }
    };

    // 处理颜色选择
    const handleColorSelect = async (colorId) => {
        // 🔥 获取当前记录信息
        const recordInfo = getCurrentRecordInfo();

        // 🔥 新增：防重复点击检查 - 如果当前模板选择器正在加载，直接返回
        if (recordInfo && loadingCovers[recordInfo.recordId]) {
            Toast.info('正在生成封面中，请稍后再试');
            return;
        }

        setSelectedColor(colorId);
        const selectedColorInfo = colorOptions.find((c) => c.id === colorId);

        // 🔥 获取当前记录信息并调用封面更新接口
        if (recordInfo && selectedColorInfo) {
            try {
                // 🔥 修改：设置特定模板选择器的加载状态
                setLoadingCovers((prev) => {
                    const newState = {
                        ...prev,
                        [recordInfo.recordId]: true
                    };
                    return newState;
                });
                // 🔥 新增：记录设置加载状态的时间戳
                loadingCoversStartTimeRef.current[recordInfo.recordId] = Date.now();

                // 🔥 修复：优先使用当前选中的风格，而不是从历史数据获取
                const currentStyle = selectedStyle;

                const updateData = {
                    _id: recordInfo.recordId,
                    user_id: recordInfo.userId,
                    agent_id: recordInfo.agentId,
                    session_id: recordInfo.sessionId,
                    skill_id: recordInfo.skillId,
                    skill_name: recordInfo.skillName,
                    skill_describe: recordInfo.skillDescribe,
                    apart: recordInfo.apart,
                    question: {
                        color: selectedColorInfo.name,
                        style: currentStyle
                    },
                    file_json: [],
                    plugin_json: {
                        deep_think: false,
                        web_search: false
                    },
                    session_key: recordInfo.sessionKey
                };

                const response = await handleAIPPTCoverUpdate(updateData);

                // 🔥 如果API返回成功，更新封面数据并关闭加载状态
                if (response && response.success && response.data && response.data.cover_image_list) {
                    setCoverImages(response.data.cover_image_list);
                    // 🔥 修改：只关闭当前模板选择器的加载状态
                    setLoadingCovers((prev) => ({
                        ...prev,
                        [recordInfo.recordId]: false
                    }));
                    // 🔥 新增：清除时间戳记录
                    delete loadingCoversStartTimeRef.current[recordInfo.recordId];

                    // 🔥 修复：优先从originMsgMapRef获取最新数据进行更新
                    const effectiveSessionId = localStorage.getItem('aippt_prev_session_id');
                    let baseMessages = [];

                    // 优先从originMsgMapRef获取最新数据
                    if (effectiveSessionId && originMsgMapRef[effectiveSessionId]?.messages) {
                        baseMessages = [...originMsgMapRef[effectiveSessionId].messages];
                    } else if (messages.length > 0) {
                        baseMessages = [...messages];
                    }

                    // 🔥 更新消息历史中的模板选择数据
                    const updatedMessages = baseMessages.map((msg) => {
                        // 🔥 查找包含模板选择器的消息（可能是React组件、普通对象或apiData格式）
                        if (msg.role === 'assistant' && (msg._id === recordInfo.recordId || msg.apiData?._id === recordInfo.recordId)) {
                            // 🔥 新增：如果是apiData格式
                            if (msg.apiData && msg.apiData._id === recordInfo.recordId) {
                                return {
                                    ...msg,
                                    apiData: {
                                        ...msg.apiData,
                                        cover_image_list: response.data.cover_image_list,
                                        color: selectedColorInfo ? selectedColorInfo.name : '蓝色', // 🔥 修复：使用正确的默认颜色
                                        style: currentStyle,
                                        ongoing_status: '1' // 🔥 修复：更新ongoing_status为"1"，显示正常状态
                                    }
                                };
                            }
                            // 如果是React组件
                            else if (React.isValidElement(msg.content) && msg.content.type === TemplateSelector) {
                                const updatedProps = {
                                    ...msg.content.props,
                                    historyData: {
                                        ...msg.content.props.historyData,
                                        cover_image_list: response.data.cover_image_list,
                                        color: selectedColorInfo ? selectedColorInfo.name : '蓝色', // 🔥 修复：使用正确的默认颜色
                                        style: currentStyle
                                    }
                                };

                                return {
                                    ...msg,
                                    content: React.cloneElement(msg.content, updatedProps)
                                };
                            }
                            // 🔥 如果是普通对象且包含封面数据
                            else if (
                                msg.content &&
                                typeof msg.content === 'object' &&
                                (msg.content.cover_image_list || msg.content.color || msg.content.style)
                            ) {
                                return {
                                    ...msg,
                                    content: {
                                        ...msg.content,
                                        cover_image_list: response.data.cover_image_list,
                                        color: selectedColorInfo ? selectedColorInfo.name : '蓝色', // 🔥 修复：使用正确的默认颜色
                                        style: currentStyle,
                                        ongoing_status: '1' // 🔥 修复：更新ongoing_status为"1"，显示正常状态
                                    }
                                };
                            }
                        }
                        return msg;
                    });

                    // 🔥 修复：更新本地状态
                    setMessages(updatedMessages);

                    // 🔥 修复：同步到sessionMap，确保数据持久化
                    if (effectiveSessionId && changeSessionMapItem && typeof changeSessionMapItem === 'function') {
                        try {
                            changeSessionMapItem(
                                effectiveSessionId,
                                {
                                    messages: updatedMessages
                                },
                                updatedMessages
                            );
                        } catch (error) {
                            console.error('🔥 颜色更新同步到sessionMap失败:', error);
                        }
                    }
                } else {
                    console.warn('🔥 API返回数据格式异常:', response);
                    // 🔥 修改：关闭特定模板选择器的加载状态
                    setLoadingCovers((prev) => ({
                        ...prev,
                        [recordInfo.recordId]: false
                    }));
                    // 🔥 新增：清除时间戳记录
                    delete loadingCoversStartTimeRef.current[recordInfo.recordId];
                }
            } catch (error) {
                console.error('🔥 颜色更新失败:', error);
                // 🔥 修改：如果出错，关闭特定模板选择器的加载状态
                setLoadingCovers((prev) => ({
                    ...prev,
                    [recordInfo.recordId]: false
                }));
                // 🔥 新增：清除时间戳记录
                delete loadingCoversStartTimeRef.current[recordInfo.recordId];
            }
        } else {
            console.warn('🔥 无法获取记录信息或颜色信息');
        }
    };

    // 处理风格选择
    const handleStyleSelect = async (style) => {
        // 🔥 获取当前记录信息
        const recordInfo = getCurrentRecordInfo();

        // 🔥 新增：防重复点击检查 - 如果当前模板选择器正在加载，直接返回
        if (recordInfo && loadingCovers[recordInfo.recordId]) {
            Toast.info('正在生成封面中，请稍后再试');
            return;
        }

        setSelectedStyle(style);

        // 🔥 获取当前记录信息并调用封面更新接口
        if (recordInfo) {
            try {
                // 🔥 修改：设置特定模板选择器的加载状态
                setLoadingCovers((prev) => {
                    const newState = {
                        ...prev,
                        [recordInfo.recordId]: true
                    };
                    return newState;
                });
                // 🔥 新增：记录设置加载状态的时间戳
                loadingCoversStartTimeRef.current[recordInfo.recordId] = Date.now();

                // 🔥 修复：优先使用当前选中的颜色，而不是从历史数据获取
                const selectedColorInfo = colorOptions.find((c) => c.id === selectedColor);
                const currentColor = selectedColorInfo ? selectedColorInfo.name : '蓝色';

                const updateData = {
                    _id: recordInfo.recordId,
                    user_id: recordInfo.userId,
                    agent_id: recordInfo.agentId,
                    session_id: recordInfo.sessionId,
                    skill_id: recordInfo.skillId,
                    skill_name: recordInfo.skillName,
                    skill_describe: recordInfo.skillDescribe,
                    apart: recordInfo.apart,
                    question: {
                        color: currentColor,
                        style: style
                    },
                    file_json: [],
                    plugin_json: {
                        deep_think: false,
                        web_search: false
                    },
                    session_key: recordInfo.sessionKey
                };

                const response = await handleAIPPTCoverUpdate(updateData);

                // 🔥 如果API返回成功，更新封面数据并关闭加载状态
                if (response && response.success && response.data && response.data.cover_image_list) {
                    setCoverImages(response.data.cover_image_list);
                    // 🔥 修改：只关闭当前模板选择器的加载状态
                    setLoadingCovers((prev) => ({
                        ...prev,
                        [recordInfo.recordId]: false
                    }));
                    // 🔥 新增：清除时间戳记录
                    delete loadingCoversStartTimeRef.current[recordInfo.recordId];

                    // 🔥 修复：优先从originMsgMapRef获取最新数据进行更新
                    const effectiveSessionId = localStorage.getItem('aippt_prev_session_id');
                    let baseMessages = [];

                    // 优先从originMsgMapRef获取最新数据
                    if (effectiveSessionId && originMsgMapRef[effectiveSessionId]?.messages) {
                        baseMessages = [...originMsgMapRef[effectiveSessionId].messages];
                    } else if (messages.length > 0) {
                        baseMessages = [...messages];
                    }

                    // 🔥 更新消息历史中的模板选择数据
                    const updatedMessages = baseMessages.map((msg) => {
                        // 🔥 查找包含模板选择器的消息（可能是React组件、普通对象或apiData格式）
                        if (msg.role === 'assistant' && (msg._id === recordInfo.recordId || msg.apiData?._id === recordInfo.recordId)) {
                            // 🔥 新增：如果是apiData格式
                            if (msg.apiData && msg.apiData._id === recordInfo.recordId) {
                                return {
                                    ...msg,
                                    apiData: {
                                        ...msg.apiData,
                                        cover_image_list: response.data.cover_image_list,
                                        color: currentColor,
                                        style: style,
                                        ongoing_status: '1' // 🔥 修复：更新ongoing_status为"1"，显示正常状态
                                    }
                                };
                            }
                            // 如果是React组件
                            else if (React.isValidElement(msg.content) && msg.content.type === TemplateSelector) {
                                const updatedProps = {
                                    ...msg.content.props,
                                    historyData: {
                                        ...msg.content.props.historyData,
                                        cover_image_list: response.data.cover_image_list,
                                        color: currentColor,
                                        style: style
                                    }
                                };

                                return {
                                    ...msg,
                                    content: React.cloneElement(msg.content, updatedProps)
                                };
                            }
                            // 🔥 如果是普通对象且包含封面数据
                            else if (
                                msg.content &&
                                typeof msg.content === 'object' &&
                                (msg.content.cover_image_list || msg.content.color || msg.content.style)
                            ) {
                                return {
                                    ...msg,
                                    content: {
                                        ...msg.content,
                                        cover_image_list: response.data.cover_image_list,
                                        color: currentColor,
                                        style: style,
                                        ongoing_status: '1' // 🔥 修复：更新ongoing_status为"1"，显示正常状态
                                    }
                                };
                            }
                        }
                        return msg;
                    });

                    // 🔥 修复：更新本地状态
                    setMessages(updatedMessages);

                    // 🔥 修复：同步到sessionMap，确保数据持久化
                    if (effectiveSessionId && changeSessionMapItem && typeof changeSessionMapItem === 'function') {
                        try {
                            changeSessionMapItem(
                                effectiveSessionId,
                                {
                                    messages: updatedMessages
                                },
                                updatedMessages
                            );
                        } catch (error) {
                            console.error('🔥 风格更新同步到sessionMap失败:', error);
                        }
                    }
                } else {
                    console.warn('🔥 API返回数据格式异常:', response);
                    // 🔥 修改：关闭特定模板选择器的加载状态
                    setLoadingCovers((prev) => ({
                        ...prev,
                        [recordInfo.recordId]: false
                    }));
                    // 🔥 新增：清除时间戳记录
                    delete loadingCoversStartTimeRef.current[recordInfo.recordId];
                }
            } catch (error) {
                console.error('🔥 风格更新失败:', error);
                // 🔥 修改：如果出错，关闭特定模板选择器的加载状态
                setLoadingCovers((prev) => ({
                    ...prev,
                    [recordInfo.recordId]: false
                }));
                // 🔥 新增：清除时间戳记录
                delete loadingCoversStartTimeRef.current[recordInfo.recordId];
            }
        } else {
            console.warn('🔥 无法获取记录信息');
        }
    };
    // 处理消息列表数据
    const getItem = () => {
        // 🔥 修复：参考 chat.jsx 的逻辑
        // 默认使用 'agent' 类型（显示智能体样式，带图片）
        // 只有当技能正常显示时（left_side === 1 且 apart === true）才使用 'skill' 类型
        let type = 'agent'; // 默认使用 agent 类型
        // 🔥 修复：默认使用智能体的预设问题（通用技能）
        let preQuestion = currentAgent?.pre_question_json;

        // 🔥 修复：默认使用通用技能的欢迎语（当 AIPPT 下架时会回退到通用技能）
        let agentInfo = {
            introduction:
                curSkill?.show_description ||
                curSkill?.third_json?.description ||
                currentAgent?.introduction ||
                `Hi~，我是${curSkill?.show_name || currentAgent?.name || 'AI助手'}`,
            name: curSkill?.show_name || curSkill?.ability_name || currentAgent?.name || 'AI助手'
        };
        let showGuide = false;
        let guideData = [];

        // 🔥 修复：只有当技能正常显示时才使用 skill 类型和 AIPPT 专用欢迎语
        // 参考 chat.jsx: if (curSkill?.ability_id != -1 && curSkill?.apart)
        if (curSkill?.ability_id != -1) {
            type = 'skill';
            // 🔥 修复：隔离技能使用技能的预设问题
            preQuestion = skillPreQuestion;
        }

        // 🔥 新增：在渲染前检查是否有加载消息，如果有则派发加载开始事件
        const effectiveSessionId = localStorage.getItem('aippt_prev_session_id') || sessionId;
        let hasGlobalLoadingMessage = false;

        // 🔥 修改：优先使用本地消息状态，特别是对于假会话
        let chatMessages = [];

        // 🔥 优先使用originMsgMapRef中的消息，这是最新的数据源
        if (effectiveSessionId && originMsgMapRef?.[effectiveSessionId]?.messages) {
            const currentMessagesArray = originMsgMapRef?.[effectiveSessionId].messages; // 🔥 定义当前分支的消息数组
            // 🔥 新增：检查是否有加载消息
            hasGlobalLoadingMessage = currentMessagesArray.some(
                (msg) =>
                    msg.loading === true ||
                    (msg.content && React.isValidElement(msg.content) && msg.content.type === DotsLoading) ||
                    (msg.content && typeof msg.content === 'object' && msg.content.ongoing_status === '0') ||
                    (typeof msg.content === 'string' && msg.content.includes('正在生成'))
            );
            chatMessages = currentMessagesArray.map((msg, msgIndex) => {
                // 🔥 修复：同时支持 'user' 和 'local' 作为用户消息的标识
                // 'user' 是 AIPPT 历史消息的角色标识
                // 'local' 是通用技能用户消息的角色标识
                const isUserMessage = msg.role === 'user' || msg.role === 'local';

                if (isUserMessage) {
                    // 🔥 修复：检查用户消息的 content 是否为普通对象
                    let userContent = msg.content;

                    // 如果用户消息的 content 是普通对象，需要进行处理
                    if (userContent && typeof userContent === 'object' && !React.isValidElement(userContent) && userContent.constructor === Object) {
                        // 如果包含 theme 字段，优先显示主题（无论是否有 ongoing_status）
                        if (userContent.theme !== undefined) {
                            userContent = `${userContent.theme}`;
                        } else if (userContent.ongoing_status !== undefined) {
                            userContent = `状态：${userContent.ongoing_status}`;
                        } else {
                            // 其他类型的对象，转换为JSON字符串
                            userContent = JSON.stringify(userContent);
                        }
                    }

                    return {
                        ...msg, // 🔥 保留原始消息的所有属性
                        role: 'local', // 用户消息显示在右边
                        content: <div className={s['plain-user-message']}>{userContent}</div>
                    };
                } else {
                    // 🔥 新增：优先检查消息的loading状态，如果正在加载则显示加载组件
                    if (msg.loading === true || msg.status === 'loading') {
                        return {
                            ...msg,
                            role: 'ai',
                            content: (
                                <div
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        borderRadius: '12px',
                                        margin: '8px 0'
                                    }}
                                >
                                    <DotsLoading />
                                </div>
                            )
                        };
                    }

                    // 🔥 修复：检查 AI 消息的 content 是否为普通对象
                    let aiContent = msg.content;

                    // 🔥 优先使用apiData（如果存在），因为它包含最新的更新数据
                    if (msg.apiData) {
                        aiContent = msg.apiData;
                    }

                    // 🔥 如果没有apiData，且消息内容是React组件且包含historyData，使用组件的historyData
                    else if (React.isValidElement(msg.content) && msg.content?.props && msg.content.props?.historyData) {
                        aiContent = msg.content.props.historyData;
                    } else if (
                        React.isValidElement(msg.content) &&
                        msg.content?.props &&
                        msg.content.props?.apiData?.data?.content_type === 'aippt_catalog'
                    ) {
                        aiContent = msg.content?.props?.apiData?.data;
                    }

                    // 🔥 新增：如果 aiContent 是字符串（通用技能返回的文本或HTML）
                    if (typeof aiContent === 'string') {
                        // 🔥 修复：如果字符串为空且消息正在加载，显示加载状态
                        if (aiContent.trim() === '' && (msg.loading || msg.status === 'loading')) {
                            return {
                                ...msg,
                                role: 'ai',
                                content: (
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            borderRadius: '12px',
                                            margin: '8px 0'
                                        }}
                                    >
                                        <DotsLoading />
                                    </div>
                                )
                            };
                        }

                        // 🔥 修复：检查字符串是否包含HTML标签，如果是则使用dangerouslySetInnerHTML渲染
                        // 否则直接显示纯文本
                        const isHTML = /<[^>]+>/.test(aiContent);

                        return {
                            ...msg,
                            role: 'ai',
                            content: isHTML ? <div dangerouslySetInnerHTML={{ __html: aiContent }} /> : aiContent
                        };
                    }

                    // 🔥 新增：如果 aiContent 是数组，将其转换为安全的显示格式
                    if (Array.isArray(aiContent)) {
                        console.warn('🔥 AI消息内容是数组类型，这可能是数据格式异常:', aiContent);

                        // 尝试将数组内容合并为字符串显示
                        const arrayContent = aiContent
                            .map((item, index) => {
                                if (typeof item === 'string') {
                                    return item;
                                } else if (item && typeof item === 'object') {
                                    return JSON.stringify(item);
                                } else {
                                    return String(item);
                                }
                            })
                            .filter((item) => item) // 过滤掉空值
                            .join('\n');

                        return {
                            ...msg,
                            role: 'ai',
                            content: arrayContent || '数据格式异常，请重试'
                        };
                    }

                    // 如果 content 是普通对象且包含 ongoing_status 和 theme 等字段
                    if (aiContent && typeof aiContent === 'object' && !React.isValidElement(aiContent) && aiContent.constructor === Object) {
                        // 🔥 新增：优先检查是否为失败状态（ongoing_status为"3"但没有有效数据）
                        if (
                            aiContent.ongoing_status === '3' &&
                            (!aiContent.catalogs || !Array.isArray(aiContent.catalogs) || aiContent.catalogs.length === 0) &&
                            !aiContent.images_url &&
                            aiContent.status !== 2 &&
                            !aiContent.cover_image_list
                        ) {
                            aiContent = <div style={{ textAlign: 'center' }}>生成失败，请重试</div>;
                        }
                        // 🔥 检查是否为PPT封面数据（content_type: "aippt_cover"）
                        else if (
                            (msg.content_type === 'aippt_cover' && aiContent.ongoing_status !== undefined) ||
                            aiContent.content_type === 'aippt_cover'
                        ) {
                            // 🔥 检查 ongoing_status，如果为 "0" 则显示加载状态（无论是否有cover_image_list）
                            if (aiContent.ongoing_status === '0') {
                                // 🔥 新增：派发AIPPT加载开始事件，确保WebSender显示暂停图标
                                window.dispatchEvent(
                                    new CustomEvent('aippt-loading-start', {
                                        detail: {
                                            sessionId: sessionId,
                                            timestamp: Date.now(),
                                            type: 'render_loading_message' // 标记为渲染加载消息
                                        }
                                    })
                                );

                                // 🔥 如果有cover_image_list，显示"正在生成新的封面"，否则显示三个点
                                if (aiContent.cover_image_list && aiContent.cover_image_list.length > 0) {
                                    // 显示模板选择器但处于加载状态
                                    const { defaultColor, defaultStyle } = getDefaultSelectionFromResponse(aiContent);

                                    aiContent = (
                                        <TemplateSelector
                                            templates={[]}
                                            colorOptions={colorOptions}
                                            styleOptions={styleOptions}
                                            selectedTemplate={selectedTemplate}
                                            selectedColor={defaultColor}
                                            selectedStyle={defaultStyle}
                                            onColorSelect={handleColorSelect}
                                            onStyleSelect={handleStyleSelect}
                                            onConfirm={handleTemplateSelect}
                                            historyData={aiContent}
                                            isHistoryMode={true}
                                            recordId={msg._id || 'default'}
                                            loadingCovers={{ [msg._id || 'default']: true }} // 🔥 强制显示加载状态
                                            message={msg}
                                            chatHistory={currentMessagesArray}
                                            isCompleted={false}
                                        />
                                    );
                                } else {
                                    // 显示三个点加载状态
                                    aiContent = (
                                        <div
                                            style={{
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                borderRadius: '12px',
                                                margin: '8px 0'
                                            }}
                                        >
                                            <DotsLoading />
                                        </div>
                                    );
                                }
                            }
                            // 🔥 如果 ongoing_status 为 "1" 且有 cover_image_list，显示封面选择界面
                            else if (aiContent.ongoing_status === '1' && aiContent.cover_image_list && aiContent.cover_image_list.length > 0) {
                                // 🔥 根据历史数据获取默认选中状态
                                const { defaultColor, defaultStyle } = getDefaultSelectionFromResponse(aiContent);

                                // 🔥 修复：检查是否已完成（优先检查消息的isCompleted标记）
                                const hasCompletedAfter =
                                    msg.isCompleted === true ||
                                    aiContent.ongoing_status === '3' ||
                                    currentMessagesArray.slice(currentMessagesArray.indexOf(msg) + 1).some((laterMsg) => {
                                        const content = laterMsg.content;
                                        return (
                                            content &&
                                            typeof content === 'object' &&
                                            ((content.content_type === 'aippt_result' && content.images_url) ||
                                                (content.images_url && content.status === 2) ||
                                                (React.isValidElement(content) && content.type && content.type.name === 'ImageWithButtons'))
                                        );
                                    });

                                aiContent = (
                                    <TemplateSelector
                                        templates={[]}
                                        colorOptions={colorOptions}
                                        styleOptions={styleOptions}
                                        selectedTemplate={selectedTemplate}
                                        selectedColor={defaultColor}
                                        selectedStyle={defaultStyle}
                                        onColorSelect={handleColorSelect}
                                        onStyleSelect={handleStyleSelect}
                                        onConfirm={handleTemplateSelect}
                                        // 🔥 传入历史封面数据
                                        historyData={aiContent}
                                        isHistoryMode={true}
                                        recordId={msg._id || 'default'}
                                        loadingCovers={loadingCovers}
                                        message={msg} // 🔥 新增：传递当前消息
                                        chatHistory={messages} // 🔥 修复：传递当前消息数组
                                        isCompleted={hasCompletedAfter} // 🔥 新增：根据后续消息判断是否完成
                                    />
                                );
                            }
                        }
                        // 🔥 检查是否为PPT目录生成数据
                        else if (msg.content_type === 'aippt_catalog') {
                            // 🔥 aippt_catalog 类型：ongoing_status为"0"时显示加载状态
                            if (aiContent.ongoing_status === '0') {
                                // 🔥 新增：派发AIPPT加载开始事件，确保WebSender显示暂停图标
                                window.dispatchEvent(
                                    new CustomEvent('aippt-loading-start', {
                                        detail: {
                                            sessionId: sessionId,
                                            timestamp: Date.now(),
                                            type: 'render_catalog_loading' // 标记为渲染目录加载
                                        }
                                    })
                                );

                                // 显示加载中状态
                                aiContent = (
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            borderRadius: '12px',
                                            margin: '8px 0'
                                        }}
                                    >
                                        <DotsLoading />
                                    </div>
                                );
                            }
                            // 🔥 新增：ongoing_status为"2"时显示生成失败
                            else if (aiContent.ongoing_status === '2') {
                                aiContent = <div>生成失败，请重试</div>;
                            }
                        }
                        // 🔥 检查是否为PPT生成结果数据（支持多种数据结构）
                        else if (
                            (msg.content_type === 'aippt_result' && aiContent.ongoing_status !== undefined) ||
                            aiContent.content_type === 'aippt_result'
                        ) {
                            // 🔥 修复：只有当ongoing_status为"0"且status不为2时才显示加载状态
                            // status为2表示生成完成，即使ongoing_status为"0"也不应该显示加载
                            if (aiContent.ongoing_status === '0' && aiContent.status !== 2) {
                                // 🔥 新增：派发AIPPT加载开始事件，确保WebSender显示暂停图标
                                window.dispatchEvent(
                                    new CustomEvent('aippt-loading-start', {
                                        detail: {
                                            sessionId: sessionId,
                                            timestamp: Date.now(),
                                            type: 'render_result_loading' // 标记为渲染结果加载
                                        }
                                    })
                                );

                                // 显示加载中状态
                                aiContent = (
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            borderRadius: '12px',
                                            margin: '8px 0'
                                        }}
                                    >
                                        <DotsLoading />
                                    </div>
                                );
                            }
                            // 🔥 如果有 images_url 且状态为已完成，显示结果
                            else if (aiContent.images_url || aiContent.status === 2) {
                                // 🔥 如果是嵌套结构，提取真实的结果数据
                                const actualResult = aiContent.resultResponse || aiContent;

                                // 🔥 从消息中提取PPT ID，支持多种数据结构
                                const pptId =
                                    msg.pptId || // 优先使用消息级别保存的pptId
                                    actualResult.id ||
                                    actualResult.ppt_id ||
                                    aiContent.createResponse?.id ||
                                    aiContent.id ||
                                    aiContent.ppt_id ||
                                    aiContent.content?.id ||
                                    msg.content?.id ||
                                    msg._id;

                                // 创建ImageWithButtons组件来显示PPT生成结果
                                aiContent = (
                                    <ImageWithButtons
                                        imageUrl={actualResult.images_url || aiContent.images_url || '/favicon.ico'}
                                        imageAlt="PPT预览"
                                        buttonText1="编辑"
                                        buttonText2="下载"
                                        pptId={pptId} // 🔥 传递提取的PPT ID
                                        onButton1Click={() => {
                                            // 调用编辑PPT接口，优先使用提取的pptId
                                            handleAIPPTEditorClick(pptId || actualResult);
                                        }}
                                        onButton2Click={() => {
                                            // 调用下载PPT接口，优先使用提取的pptId
                                            handleAIPPTDownloadClick(pptId || actualResult);
                                        }}
                                    />
                                );
                            }
                        }

                        // 检查是否为AI PPT大纲数据（包含 catalogs 或 title 字段）
                        else if (aiContent.catalogs !== undefined || aiContent.title !== undefined) {
                            // 🔥 新增：检查是否为失败状态（ongoing_status为"3"但没有有效的catalogs数据）
                            if (
                                aiContent.ongoing_status === '3' &&
                                (!aiContent.catalogs || !Array.isArray(aiContent.catalogs) || aiContent.catalogs.length === 0)
                            ) {
                                aiContent = <div style={{ textAlign: 'center' }}>生成失败，请重试</div>;
                            } else {
                                // 🔥 检查 ongoing_status 是否为 "3" 或者消息被标记为已完成，决定是否为只读模式
                                // 🔥 新增：如果消息内容是React组件，也检查组件props中的状态
                                const isReadOnly =
                                    aiContent.ongoing_status === '3' ||
                                    msg.isCompleted === true ||
                                    (msg.apiData && msg.apiData.ongoing_status === '3') ||
                                    (React.isValidElement(msg.content) &&
                                        msg.content.props &&
                                        (msg.content.props.ongoing_status === '3' || msg.content.props.isCompleted === true)) ||
                                    (React.isValidElement(msg.content) &&
                                        msg.content.props &&
                                        msg.content.props.contentProps &&
                                        (msg.content.props.contentProps.ongoing_status === '3' ||
                                            msg.content.props.contentProps.isCompleted === true));

                                // 创建 AIPPTExample 组件来渲染这个数据
                                aiContent = (
                                    <AIPPTExample
                                        apiData={{
                                            success: true,
                                            data: aiContent
                                        }}
                                        onGenerate={handleGenerateClick}
                                        agentId={agentId || currentAgent?.agent_id || '1957681408981704706'}
                                        sessionId={sessionId}
                                        skillId={curSkill?.ability_id || skillId || '1957685884025380865'}
                                        curSkill={curSkill}
                                        conversationId={conversationId}
                                        sessionMap={sessionMap}
                                        curPlugin={curPlugin}
                                        // 🔥 新增：传递只读状态
                                        isReadOnly={isReadOnly}
                                        getItem={getItem} // 🔥 传递getItem方法
                                    />
                                );
                            }
                        }
                        // 🔥 新增：检查是否为模板选择数据（包含 cover_image_list 或 color 字段）
                        else if (aiContent.cover_image_list !== undefined || (aiContent.color !== undefined && aiContent.style !== undefined)) {
                            // 🔥 新增：检查是否为有效的模板选择数据，避免渲染假数据
                            const hasValidCoverData =
                                aiContent.cover_image_list && Array.isArray(aiContent.cover_image_list) && aiContent.cover_image_list.length > 0;

                            if (!hasValidCoverData && (!aiContent.color || !aiContent.style)) {
                                // 如果数据不完整，显示加载状态或跳过
                                aiContent = (
                                    <div
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            background: '#f8f9fa',
                                            borderRadius: '12px',
                                            margin: '8px 0'
                                        }}
                                    >
                                        <span style={{ color: 'var(--color-grt-primary)' }}>正在加载模板数据...</span>
                                    </div>
                                );
                            } else {
                                // 🔥 根据历史数据获取默认选中状态
                                const { defaultColor, defaultStyle } = getDefaultSelectionFromResponse(aiContent);

                                // 🔥 修复：使用通用的完成状态检查函数，优先检查isCompleted标记
                                const hasCompletedAfter =
                                    msg.isCompleted === true ||
                                    aiContent.ongoing_status === '3' ||
                                    (msg.apiData && msg.apiData.ongoing_status === '3') ||
                                    checkIsCompleted(msg, currentMessagesArray);

                                // 创建模板选择器组件来渲染历史的模板选择数据
                                aiContent = (
                                    <TemplateSelector
                                        templates={[]}
                                        colorOptions={colorOptions}
                                        styleOptions={styleOptions}
                                        selectedTemplate={selectedTemplate}
                                        selectedColor={defaultColor}
                                        selectedStyle={defaultStyle}
                                        onColorSelect={handleColorSelect}
                                        onStyleSelect={handleStyleSelect}
                                        onConfirm={handleTemplateSelect}
                                        // 🔥 传入历史封面数据
                                        historyData={aiContent}
                                        isHistoryMode={true}
                                        recordId={msg.apiData?._id || msg._id || 'default'}
                                        loadingCovers={loadingCovers}
                                        message={msg} // 🔥 新增：传递当前消息
                                        chatHistory={currentMessagesArray} // 🔥 修复：传递当前分支的消息历史
                                        isCompleted={hasCompletedAfter} // 🔥 新增：根据后续消息判断是否完成
                                    />
                                );
                            }
                        }

                        // 🔥 兼容旧格式：检查其他PPT结果格式
                        else if (
                            (aiContent.images_url && aiContent.status === 2) ||
                            (aiContent.resultResponse && aiContent.resultResponse.content_type === 'aippt_result')
                        ) {
                            // 🔥 如果是嵌套结构，提取真实的结果数据
                            const actualResult = aiContent.resultResponse || aiContent;

                            // 🔥 从消息中提取PPT ID，支持多种数据结构
                            const pptId =
                                msg.pptId || // 优先使用消息级别保存的pptId
                                actualResult.id ||
                                actualResult.ppt_id ||
                                aiContent.createResponse?.id ||
                                aiContent.id ||
                                aiContent.ppt_id ||
                                aiContent.content?.id;

                            // 创建ImageWithButtons组件来显示PPT生成结果
                            aiContent = (
                                <ImageWithButtons
                                    imageUrl={actualResult.images_url || aiContent.images_url || '/favicon.ico'}
                                    imageAlt="PPT预览"
                                    buttonText1="编辑"
                                    buttonText2="下载"
                                    pptId={pptId} // 🔥 传递提取的PPT ID
                                    onButton1Click={() => {
                                        // 调用编辑PPT接口，优先使用提取的pptId
                                        handleAIPPTEditorClick(pptId || actualResult);
                                    }}
                                    onButton2Click={() => {
                                        // 调用下载PPT接口，优先使用提取的pptId
                                        handleAIPPTDownloadClick(pptId || actualResult);
                                    }}
                                />
                            );
                        } else {
                            // 其他类型的对象，转换为字符串显示
                            aiContent = <div>数据: {JSON.stringify(aiContent, null, 2)}</div>;
                        }
                    }

                    return {
                        ...msg, // 🔥 保留原始消息的所有属性
                        role: 'ai', // AI消息显示在左边
                        content: aiContent
                    };
                }
            });
        }

        const result = [
            {
                role: 'pre', // 🔥 修复：使用 'pre' role 确保欢迎语宽度正确（与 chat.jsx 保持一致）
                className: 'initial-message', // 添加特殊类名标识第一个默认消息
                // 🔥 修复：添加 avatar 属性，参考 chat.jsx 的实现
                avatar: <img className={s['ai-avatar']} src={currentAgent?.agent_icon} onError={handleImageError}></img>,
                variant: 'borderless',
                content: (
                    <PreQuestion
                        disabled={!skillStore.skillAvailable}
                        type={type}
                        guideData={guideData}
                        showGuide={showGuide}
                        curSkill={curSkill}
                        clickGuide={clickGuide}
                        pre_question_json={preQuestion}
                        submitMsg={handleAIPPTSubmit} // 使用AI PPT专用的提交函数
                        currentAgent={agentInfo}
                    ></PreQuestion>
                )
            },
            ...chatMessages
        ];

        // 🔥 新增：如果检测到加载消息，派发加载开始事件
        if (hasGlobalLoadingMessage) {
            // 使用setTimeout确保在组件渲染完成后派发事件
            setTimeout(() => {
                window.dispatchEvent(
                    new CustomEvent('aippt-loading-start', {
                        detail: {
                            sessionId: effectiveSessionId,
                            timestamp: Date.now(),
                            type: 'getItem_global_check' // 标记为getItem全局检查
                        }
                    })
                );
            }, 0);
        }

        // 🔥 新增：AIPPT 专用的最终安全检查，确保所有传递给 Bubble 的 content 都是安全的
        const safeResult = result.map((item, index) => {
            if (!item || !item.content) {
                return item;
            }

            let safeContent = item.content;

            // 🔥 强化安全检查：检查 content 是否为普通对象（非 React 元素）
            if (safeContent && typeof safeContent === 'object' && !React.isValidElement(safeContent) && safeContent.constructor === Object) {
                // 🔥 新增：优先检查是否为失败状态（ongoing_status为"3"但没有有效数据）
                if (
                    safeContent.ongoing_status === '3' &&
                    (!safeContent.catalogs || !Array.isArray(safeContent.catalogs) || safeContent.catalogs.length === 0) &&
                    !safeContent.images_url &&
                    safeContent.status !== 2 &&
                    !safeContent.cover_image_list
                ) {
                    safeContent = <div style={{ color: '#ff4d4f', padding: '12px 0', textAlign: 'center' }}>生成失败，请重试</div>;
                }
                // 🔥 新增：检查是否为嵌套的aippt_result结构（历史记录格式）
                else if (item.content_type === 'aippt_result' && safeContent.ongoing_status !== undefined) {
                    // 🔥 修复：只有当ongoing_status为"0"且status不为2时才显示加载状态
                    // status为2表示生成完成，即使ongoing_status为"0"也不应该显示加载
                    if (safeContent.ongoing_status === '0' && safeContent.status !== 2) {
                        // 🔥 新增：派发AIPPT加载开始事件，确保WebSender显示暂停图标
                        window.dispatchEvent(
                            new CustomEvent('aippt-loading-start', {
                                detail: {
                                    sessionId: sessionId,
                                    timestamp: Date.now(),
                                    type: 'safe_result_loading' // 标记为安全检查结果加载
                                }
                            })
                        );

                        // 显示加载中状态
                        safeContent = (
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    borderRadius: '12px',
                                    margin: '8px 0'
                                }}
                            >
                                <DotsLoading />
                            </div>
                        );
                    }
                    // 🔥 如果有 images_url 且状态为已完成，显示结果
                    else if (safeContent.images_url || safeContent.status === 2) {
                        // 🔥 从消息和内容中提取PPT ID，支持多种数据结构
                        const pptId = safeContent.id || item.content?.id || item._id;

                        // 创建ImageWithButtons组件来显示PPT生成结果
                        safeContent = (
                            <ImageWithButtons
                                imageUrl={safeContent.images_url || '/favicon.ico'}
                                imageAlt="PPT预览"
                                buttonText1="编辑"
                                buttonText2="下载"
                                pptId={pptId} // 🔥 传递提取的PPT ID
                                onButton1Click={() => {
                                    // 调用编辑PPT接口，优先使用提取的pptId
                                    handleAIPPTEditorClick(pptId || safeContent);
                                }}
                                onButton2Click={() => {
                                    // 调用下载PPT接口，优先使用提取的pptId
                                    handleAIPPTDownloadClick(pptId || safeContent);
                                }}
                            />
                        );
                    }
                }
                // 检查是否为AI PPT大纲数据（包含 catalogs 或 title 字段）
                else if (safeContent.catalogs !== undefined || safeContent.title !== undefined) {
                    // 🔥 新增：检查是否为失败状态（ongoing_status为"3"但没有有效的catalogs数据）
                    if (
                        safeContent.ongoing_status === '3' &&
                        (!safeContent.catalogs || !Array.isArray(safeContent.catalogs) || safeContent.catalogs.length === 0)
                    ) {
                        safeContent = <div style={{ textAlign: 'center' }}>生成失败，请重试</div>;
                    } else {
                        // 🔥 检查 ongoing_status 是否为 "3" 或者消息被标记为已完成，决定是否为只读模式
                        // 🔥 优化：简化isReadOnly计算逻辑，优先检查最可靠的状态
                        const isReadOnly =
                            // 首先检查内容的ongoing_status（最可靠）
                            safeContent.ongoing_status === '3' ||
                            // 然后检查消息级别的完成状态
                            item.isCompleted === true ||
                            // 最后检查apiData中的状态
                            (item.apiData && item.apiData.ongoing_status === '3');

                        // 创建 AIPPTExample 组件来渲染这个数据
                        safeContent = (
                            <AIPPTExample
                                apiData={{
                                    success: true,
                                    data: safeContent
                                }}
                                onGenerate={handleGenerateClick}
                                agentId={agentId || currentAgent?.agent_id || '1957681408981704706'}
                                sessionId={sessionId}
                                skillId={curSkill?.ability_id || skillId || '1957685884025380865'}
                                curSkill={curSkill}
                                conversationId={conversationId}
                                sessionMap={sessionMap}
                                curPlugin={curPlugin}
                                // 🔥 新增：传递只读状态
                                isReadOnly={isReadOnly}
                                getItem={getItem} // 🔥 传递getItem方法
                            />
                        );
                    }
                }
                // 🔥 新增：检查是否为模板选择数据
                else if (safeContent.cover_image_list !== undefined || (safeContent.color !== undefined && safeContent.style !== undefined)) {
                    // 🔥 新增：检查是否为有效的模板选择数据，避免渲染假数据
                    const hasValidCoverData =
                        safeContent.cover_image_list && Array.isArray(safeContent.cover_image_list) && safeContent.cover_image_list.length > 0;

                    if (!hasValidCoverData && (!safeContent.color || !safeContent.style)) {
                        // 如果数据不完整，显示加载状态或跳过
                        safeContent = (
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    background: '#f8f9fa',
                                    borderRadius: '12px',
                                    margin: '8px 0'
                                }}
                            >
                                <span style={{ color: 'var(--color-grt-primary)' }}>正在加载模板数据...</span>
                            </div>
                        );
                    } else {
                        // 🔥 根据历史数据获取默认选中状态
                        const { defaultColor, defaultStyle } = getDefaultSelectionFromResponse(safeContent);

                        // 🔥 修复：检查是否已完成（优先检查消息的isCompleted标记）
                        const hasCompletedAfter =
                            item.isCompleted === true ||
                            safeContent.ongoing_status === '3' ||
                            (item.apiData && item.apiData.ongoing_status === '3') ||
                            result.slice(index + 1).some((laterItem) => {
                                const content = laterItem.content;
                                return (
                                    content &&
                                    typeof content === 'object' &&
                                    ((content.content_type === 'aippt_result' && content.images_url) ||
                                        (content.images_url && content.status === 2) ||
                                        (React.isValidElement(content) && content.type && content.type.name === 'ImageWithButtons'))
                                );
                            });

                        safeContent = (
                            <TemplateSelector
                                templates={[]}
                                colorOptions={colorOptions}
                                styleOptions={styleOptions}
                                selectedTemplate={selectedTemplate}
                                selectedColor={defaultColor}
                                selectedStyle={defaultStyle}
                                onColorSelect={handleColorSelect}
                                onStyleSelect={handleStyleSelect}
                                onConfirm={handleTemplateSelect}
                                // 🔥 传入历史封面数据
                                historyData={safeContent}
                                isHistoryMode={true}
                                recordId={item.apiData?._id || item._id || 'default'}
                                loadingCovers={loadingCovers}
                                message={item} // 🔥 新增：传递当前消息
                                chatHistory={result} // 🔥 修复：传递当前结果数组
                                isCompleted={hasCompletedAfter} // 🔥 新增：根据后续消息判断是否完成
                            />
                        );
                    }
                }
                // 🔥 新增：检查是否为PPT封面数据（content_type: "aippt_cover"）
                else if (safeContent.content_type === 'aippt_cover') {
                    // 🔥 检查 ongoing_status，如果为 "0" 则显示加载状态
                    if (safeContent.ongoing_status === '0') {
                        // 🔥 新增：派发AIPPT加载开始事件，确保WebSender显示暂停图标
                        window.dispatchEvent(
                            new CustomEvent('aippt-loading-start', {
                                detail: {
                                    sessionId: sessionId,
                                    timestamp: Date.now(),
                                    type: 'safe_cover_loading' // 标记为安全检查封面加载
                                }
                            })
                        );

                        // 显示加载中状态
                        safeContent = (
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    borderRadius: '12px',
                                    margin: '8px 0'
                                }}
                            >
                                <DotsLoading />
                            </div>
                        );
                    }
                    // 🔥 如果 ongoing_status 为 "1" 且有 cover_image_list，显示封面选择界面
                    else if (safeContent.ongoing_status === '1' && safeContent.cover_image_list && safeContent.cover_image_list.length > 0) {
                        // 🔥 根据历史数据获取默认选中状态
                        const { defaultColor, defaultStyle } = getDefaultSelectionFromResponse(safeContent);

                        // 🔥 修复：检查是否已完成（优先检查消息的isCompleted标记）
                        const hasCompletedAfter =
                            item.isCompleted === true ||
                            safeContent.ongoing_status === '3' ||
                            (item.apiData && item.apiData.ongoing_status === '3') ||
                            result.slice(index + 1).some((laterItem) => {
                                const content = laterItem.content;
                                return (
                                    content &&
                                    typeof content === 'object' &&
                                    ((content.content_type === 'aippt_result' && content.images_url) ||
                                        (content.images_url && content.status === 2) ||
                                        (React.isValidElement(content) && content.type && content.type.name === 'ImageWithButtons'))
                                );
                            });

                        safeContent = (
                            <TemplateSelector
                                templates={[]}
                                colorOptions={colorOptions}
                                styleOptions={styleOptions}
                                selectedTemplate={selectedTemplate}
                                selectedColor={defaultColor}
                                selectedStyle={defaultStyle}
                                onColorSelect={handleColorSelect}
                                onStyleSelect={handleStyleSelect}
                                onConfirm={handleTemplateSelect}
                                // 🔥 传入历史封面数据
                                historyData={safeContent}
                                isHistoryMode={true}
                                recordId={item.apiData?._id || item._id || 'default'}
                                loadingCovers={loadingCovers}
                                message={item} // 🔥 新增：传递当前消息
                                chatHistory={result} // 🔥 修复：传递当前结果数组
                                isCompleted={hasCompletedAfter} // 🔥 新增：根据后续消息判断是否完成
                            />
                        );
                    }
                }
                // 🔥 新增：检查是否为PPT生成结果数据（包含 content_type: "aippt_result" 或 images_url 字段）
                else if (safeContent.content_type === 'aippt_result') {
                    // 🔥 修复：只有当ongoing_status为"0"且status不为2时才显示加载状态
                    // status为2表示生成完成，即使ongoing_status为"0"也不应该显示加载
                    if (safeContent.ongoing_status === '0' && safeContent.status !== 2) {
                        // 🔥 新增：派发AIPPT加载开始事件，确保WebSender显示暂停图标
                        window.dispatchEvent(
                            new CustomEvent('aippt-loading-start', {
                                detail: {
                                    sessionId: sessionId,
                                    timestamp: Date.now(),
                                    type: 'safe_content_loading' // 标记为安全检查内容加载
                                }
                            })
                        );

                        // 显示加载中状态
                        safeContent = (
                            <div
                                style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    borderRadius: '12px',
                                    margin: '8px 0'
                                }}
                            >
                                <DotsLoading />
                            </div>
                        );
                    }
                    // 🔥 如果有 images_url 且状态为已完成，显示结果
                    else if (safeContent.images_url || safeContent.status === 2) {
                        // 🔥 如果是嵌套结构，提取真实的结果数据
                        const actualResult = safeContent.resultResponse || safeContent;

                        // 🔥 从消息中提取PPT ID，支持多种数据结构
                        const pptId =
                            item.pptId || // 优先使用消息级别保存的pptId
                            actualResult.id ||
                            actualResult.ppt_id ||
                            safeContent.createResponse?.id ||
                            safeContent.id ||
                            safeContent.ppt_id ||
                            safeContent.content?.id;

                        // 创建ImageWithButtons组件来显示PPT生成结果
                        safeContent = (
                            <ImageWithButtons
                                imageUrl={actualResult.images_url || safeContent.images_url || '/favicon.ico'}
                                imageAlt="PPT预览"
                                buttonText1="编辑"
                                buttonText2="下载"
                                pptId={pptId} // 🔥 传递提取的PPT ID
                                onButton1Click={() => {
                                    // 调用编辑PPT接口，优先使用提取的pptId
                                    handleAIPPTEditorClick(pptId || actualResult);
                                }}
                                onButton2Click={() => {
                                    // 调用下载PPT接口，优先使用提取的pptId
                                    handleAIPPTDownloadClick(pptId || actualResult);
                                }}
                            />
                        );
                    }
                    // 🔥 其他状态，显示状态信息
                    else {
                        // 🔥 修复：ongoing_status为"2"时显示失败信息
                        if (safeContent.ongoing_status === '2') {
                            safeContent = <div>生成失败，请重试</div>;
                        }
                    }
                }
                // 🔥 兼容旧格式：检查其他PPT结果格式
                else if (
                    (safeContent.images_url && safeContent.status === 2) ||
                    (safeContent.resultResponse && safeContent.resultResponse.content_type === 'aippt_result')
                ) {
                    // 🔥 如果是嵌套结构，提取真实的结果数据
                    const actualResult = safeContent.resultResponse || safeContent;

                    // 🔥 从消息中提取PPT ID，支持多种数据结构
                    const pptId =
                        item.pptId || // 优先使用消息级别保存的pptId
                        actualResult.id ||
                        actualResult.ppt_id ||
                        safeContent.createResponse?.id ||
                        safeContent.id ||
                        safeContent.ppt_id ||
                        safeContent.content?.id;

                    // 创建ImageWithButtons组件来显示PPT生成结果
                    safeContent = (
                        <ImageWithButtons
                            imageUrl={actualResult.images_url || safeContent.images_url || '/favicon.ico'}
                            imageAlt="PPT预览"
                            buttonText1="编辑"
                            buttonText2="下载"
                            pptId={pptId} // 🔥 传递提取的PPT ID
                            onButton1Click={() => {
                                // 调用编辑PPT接口，优先使用提取的pptId
                                handleAIPPTEditorClick(pptId || actualResult);
                            }}
                            onButton2Click={() => {
                                // 调用下载PPT接口，优先使用提取的pptId
                                handleAIPPTDownloadClick(pptId || actualResult);
                            }}
                        />
                    );
                } else if (safeContent.theme !== undefined) {
                    // 如果只有 theme 字段，显示主题信息
                    safeContent = <div className={s['plain-user-message']}>主题：{safeContent.theme}</div>;
                } else {
                    // 🔥 修复：通用技能返回的对象数据，转换为友好的显示格式
                    // 避免直接显示JSON字符串，影响用户体验
                    console.warn('🔥 AIPPT - 检测到非AIPPT格式的对象数据:', safeContent);

                    // 如果对象有可读的文本内容，提取显示；否则转为JSON字符串
                    if (safeContent.text || safeContent.message || safeContent.content) {
                        safeContent = <div>{safeContent.text || safeContent.message || safeContent.content}</div>;
                    } else {
                        // 其他类型的对象，转换为格式化的JSON字符串（调试用）
                        safeContent = (
                            <div
                                style={{
                                    background: '#f5f5f5',
                                    padding: '24px',
                                    borderRadius: '4px',
                                    fontSize: '12px',
                                    color: '#666',
                                    whiteSpace: 'pre-wrap'
                                }}
                            >
                                数据: {JSON.stringify(safeContent, null, 2)}
                            </div>
                        );
                    }
                }
            }

            // 🔥 新增：额外的安全检查，确保 content 不是数组或其他复杂类型
            if (Array.isArray(safeContent)) {
                safeContent = <div>数组数据: {JSON.stringify(safeContent, null, 2)}</div>;
            } else if (safeContent && typeof safeContent === 'function') {
                safeContent = <div>函数类型数据</div>;
            } else if (safeContent && typeof safeContent === 'symbol') {
                safeContent = <div>Symbol类型数据</div>;
            }

            return {
                ...item,
                content: safeContent
            };
        });

        return safeResult;
    };

    // 🔥 新增：错误边界处理函数
    const handleRenderError = (error) => {
        console.error('🔥 AIPPT 渲染错误:', error);
        // 如果出现渲染错误，清空消息并显示错误提示
        setMessages([]);
        return (
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: '24px',
                    color: 'red',
                    fontSize: '16px'
                }}
            >
                ⚠️ 页面渲染出错，请刷新重试
            </div>
        );
    };

    // 🔥 新增：全局错误边界
    if (!React.isValidElement) {
        console.error('🔥 React.isValidElement 不可用，使用备用检查');
        React.isValidElement = (element) => {
            return element && typeof element === 'object' && element.$$typeof === Symbol.for('react.element');
        };
    }

    return (
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            {/* 消息列表 */}
            <div className={s['chats-box']} style={{ flex: 1 }}>
                {/* 🔥 新增：错误边界包装 */}
                {(() => {
                    try {
                        return (
                            <Bubble.List
                                autoScroll={sessionId ? true : false}
                                ref={listRef}
                                key={sessionId}
                                items={(() => {
                                    try {
                                        const items = getItem();
                                        // 🔥 最后的安全检查：确保所有items都是安全的
                                        return items.map((item, index) => {
                                            if (!item || !item.content) {
                                                return item;
                                            }

                                            // 如果content仍然是对象，强制转换为安全内容
                                            if (item.content && typeof item.content === 'object' && !React.isValidElement(item.content)) {
                                                return {
                                                    ...item,
                                                    content: <div style={{ color: 'red' }}>⚠️ 数据格式错误，已自动转换</div>
                                                };
                                            }

                                            // 🔥 清理掉不应该传递给DOM的属性，避免React警告
                                            const {
                                                messageType,
                                                sessionId,
                                                apiData,
                                                apiRequestId,
                                                isApiSuccess,
                                                loadingId,
                                                requestId,
                                                pptData,
                                                pptId,
                                                answerContent,
                                                thinkContent,
                                                ...cleanItem
                                            } = item;

                                            return cleanItem;
                                        });
                                    } catch (error) {
                                        console.error('🔥 getItem 执行出错:', error);
                                        return [
                                            {
                                                role: 'ai',
                                                content: <div style={{ color: 'red' }}>⚠️ 消息加载出错，请刷新页面</div>
                                            }
                                        ];
                                    }
                                })()}
                                roles={getRoles(
                                    (loading && sessionMap?.[sessionId]?.loading) || aipptLoading,
                                    <img className={s['ai-avatar']} src={currentAgent?.agent_icon} onError={handleImageError}></img>
                                )}
                                className={`${s['chats-web-messages']} ${s['aippt-messages']}`}
                            />
                        );
                    } catch (error) {
                        console.error('🔥 Bubble.List 渲染出错:', error);
                        return handleRenderError(error);
                    }
                })()}
            </div>

            {/* 输入框区域 */}
            <Display show={showChatInterface}>
                <div className={`${s['input-wrap']} ${sidebarOpen ? s['with-sidebar'] : ''}`}>
                    <Display show={!skillStore.skillAvailable}>
                        <div
                            onClick={() => {
                                Toast.info('该技能暂不可用');
                            }}
                            className={s['unavailable-box']}
                        ></div>
                    </Display>
                    {/* 技能列表 */}
                    {/* 🔥 修复：只有当 curSkill 在当前技能列表中时才显示技能列表 */}
                    {/* 这样可以防止打开已下架技能的旧会话时，仍然显示技能列表的问题 */}
                    <Display
                        show={skillStore.skillAvailable && skillList.unApartList.length && (curSkill?.left_side === 1 || curSkill?.left_side === 2)}
                    >
                        <SkillList
                            themeColor={style.themeColor}
                            show={curSkill && (!curSkill?.apart || curSkill?.ability_id == -1)}
                            curSkill={curSkill}
                            setCurSkill={setCurSkill}
                            skillList={skillList.unApartList}
                        ></SkillList>
                    </Display>

                    {/* 输入发送组件 */}
                    <WebSender
                        skillStore={skillStore}
                        agentFileRef={agentFileRef}
                        agentFile={agentFile}
                        setAgentFile={setAgentFile}
                        themeColor={style.themeColor}
                        // placeholder={'输入你想要生成ppt的主题'}
                        startNewSession={handleStartNewMsg}
                        curSkill={curSkill}
                        setCurSkill={setCurSkill}
                        value={content}
                        plugins={curSkill?.ability_id == -1 ? defaultPlugins : curSkill?.plugin_json || []}
                        setCurPlugin={setCurPlugin}
                        curPlugin={curPlugin}
                        onSubmit={handleAIPPTSubmit} // 使用AI PPT专用的提交函数
                        onChange={setContent}
                        loading={aipptLoading || sessionMap?.[sessionId]?.loading || sessionMap?.[sessionId]?.answering}
                        sessionStatus={sessionStatus}
                        editPlanMode={editPlanMode}
                        toggleEditPlanMode={toggleEditPlanMode}
                        exitEditPlanMode={resetEditPlanMode}
                        isInputVisible={isInputVisible}
                        showTTSComponent={showTTSComponent}
                        showChatInterface={showChatInterface}
                        onTTSToggle={onTTSToggle}
                        onStop={() => {
                            const currentActiveReportId = Object.keys(generatingReports).find((id) => generatingReports[id] === true);
                            stopDeerFlow && stopDeerFlow(currentActiveReportId);
                        }}
                        activeReportId={
                            sidebarOpen && activeReportId
                                ? activeReportId
                                : Object.keys(generatingReports).find((id) => generatingReports[id] === true)
                        }
                    ></WebSender>
                </div>

                {/* 🔥 新增：AI生成内容提示 - 放在输入框下方 */}
                <div className="ai-mark" style={{ textAlign: 'center' }}>
                    <AIMarks index={0} />
                </div>
            </Display>
        </div>
    );
};

export default AIPPT;
